<template>
    <div>
        <v-sheet class="px-6 pt-6">
            <div class="container-">
                <div class="d-flex flex-wrap justify-space-between">
                    <div class="flex-1" style="flex: 8">
                        <div class="d-flex align-start justify-space-between">
                            <div class="mb-0">
                                <h5 class="mr-2 mb-0">
                                    {{ createMode ? 'New Campaign' : campaignid }}                                   
                                </h5>                                
                                <p class="text--disabled mb-0">
                                    <v-chip      
                                        v-if="statusCalc==='draft'"                                  
                                        class="mr-4 rounded-pill"   
                                        color="#565656"                                    
                                        label
                                        small
                                        text-color="white"
                                    >
                                        <!-- <v-icon small left>mdi-check</v-icon> -->
                                        {{statusCalc}}
                                    </v-chip>
                                    <v-chip     
                                        v-if="statusCalc==='running' || statusCalc==='queued'"                                                                     
                                        class="mr-4 rounded-pill"    
                                        color="#4caf50"                    
                                        label
                                        small
                                        text-color="white"
                                    >
                                        <!-- <v-icon small left>mdi-check</v-icon> -->
                                        {{statusCalc}}
                                    </v-chip>
                                    <v-chip             
                                        v-if="statusCalc==='completed'"                                                                                                
                                        class="mr-4 rounded-pill"    
                                        color="#2196f3"                                    
                                        label
                                        small
                                        text-color="white"
                                    >
                                        <!-- <v-icon small left>mdi-check</v-icon> -->
                                        {{statusCalc}}
                                    </v-chip>
                                    <v-chip             
                                        v-if="statusCalc==='stopped'"                                                                                                
                                        class="mr-4 rounded-pill"    
                                        color="#d10d13 "                        
                                        label
                                        small
                                        text-color="white"
                                    >
                                        <!-- <v-icon small left>mdi-check</v-icon> -->
                                        {{statusCalc}}
                                    </v-chip>
                                    <v-chip      
                                        v-if="statusCalc==='archived'"                                  
                                        class="mr-4 rounded-pill"     
                                        color="#0000"              
                                        text-color="white"                                 
                                        label
                                        small                                        
                                    >
                                        <!-- <v-icon small left>mdi-check</v-icon> -->
                                        {{statusCalc}}
                                    </v-chip>
                                    <v-chip      
                                        v-if="statusCalc==='proposal'"                                  
                                        class="mr-4 rounded-pill"      
                                        color="#b86c00"     
                                        text-color="white"                               
                                        label
                                        small                                        
                                    >
                                        <!-- <v-icon small left>mdi-check</v-icon> -->
                                        {{statusCalc}}
                                    </v-chip>
                                    <v-chip      
                                        v-if="statusCalc==='rejected'"                                  
                                        class="mr-4 rounded-pill"     
                                        color="red"       
                                        text-color="white"                                        
                                        label
                                        small                                        
                                    >
                                        <!-- <v-icon small left>mdi-check</v-icon> -->
                                        {{statusCalc}}
                                    </v-chip>
                                    <span v-if="id">No: {{ id }}</span>
                                </p>
                            </div>
                            <!-- <div>
                                
                            </div> -->
                        </div>
                        <div class="d-flex mb-0">
                            <p class="ma-0 mr-8">
                                <span class="font-weight-medium">{{ getSelectLabel(brandOptions, brand) }}</span
                                >
                            </p>
                        </div>
                        <!-- <p class="text--disabled">
                            {{ brand_description }}
                        </p> -->
                    </div>
                    <div class="flex-1 text-right" style="flex: 1">
                        <v-btn class="ma-2" dark color="success" :loading="loading" @click="save">
                            <v-icon class="pr-2">mdi-content-save</v-icon>
                            Save
                        </v-btn>                        
                    </div>
                    <!-- <div v-if="!createMode" class="flex-1 text-right" style="flex: 1">                        
                        <template>
                        <div class="text-center">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="ma-2" 
                                    dark 
                                    :loading="loading"                                     
                                    v-bind="attrs"
                                    v-on="on"
                                    >                                        
                                        Status
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item @click="releaseCampaign">
                                        <v-list-item-title >
                                            Publish
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="completeCampaign">
                                        <v-list-item-title >
                                            Complete
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="archiveCampaign">
                                        <v-list-item-title >
                                            Archive
                                        </v-list-item-title>
                                    </v-list-item>                                    
                                </v-list>
                            </v-menu>
                        </div>
                        </template>
                    </div> -->
                </div>


                <base-card class="h-full-">
                    <v-card-text>
                        <v-card>
                            <v-tabs vertical v-model="selectedTab" @change="tabChanged">
                                <v-tab @click="tabClicked_BasicInfo">
                                    <!-- <v-icon left>
                                        mdi-account
                                    </v-icon> -->
                                    Basic Info
                                </v-tab>
                                <v-tab @click="tabClicked_Content">
                                    <!-- <v-icon left>
                                        mdi-lock
                                    </v-icon> -->
                                    Content
                                </v-tab>
                                <v-tab @click="tabClicked_Delivery">
                                    <!-- <v-icon left>
                                        mdi-access-point
                                    </v-icon> -->
                                    Delivery
                                </v-tab>
                                <!--<v-tab @click="tabClicked_Budget">
                                    Budget
                                </v-tab>-->
                                <v-tab @click="tabClicked_Summary">
                                    <!-- <v-icon left>
                                        mdi-access-point
                                    </v-icon> -->
                                    Actions
                                </v-tab>

                                <v-tab-item transition="false">
                                    <v-form v-model="basicInfoFormValid" ref="basicInfoForm">
                                        <v-card flat>
                                            <v-card-text>
                                                <p>
                                                    Configure the basic info for this Campaign
                                                </p>
                                                <v-row>
                                                    <v-col cols="12" md="9">
                                                        <v-row>
                                                            <v-col cols="12" md="4">
                                                                <v-text-field
                                                                    v-model="campaignid"
                                                                    :rules="requiredRules"
                                                                    :validate-on-blur="false" 
                                                                    label="Campaign ID"
                                                                />
                                                            </v-col>
                                                            <v-col cols="12" md="3">
                                                                <v-text-field
                                                                    v-model="external_campaignid"                                                                                                                                        
                                                                    label="External Campaign ID"
                                                                />
                                                            </v-col>
                                                            <v-col cols="12" md="3">
                                                                <v-select                                                                     
                                                                    v-model="brand"
                                                                    :items="brandOptions"                 
                                                                    label="Brand"                                             
                                                                    :rules="requiredRules"
                                                                    :validate-on-blur="false" 
                                                                    :clearable="true"                      
                                                                />                                                            
                                                            </v-col>       
                                                            <v-col cols="12" md="2">
                                                                <v-checkbox                                                                     
                                                                    v-model="is_proposal"                                                                                  
                                                                    label="Proposal"                                                              
                                                                />                                                            
                                                            </v-col>                                  
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" md="4">
                                                                <v-select                                                                     
                                                                    v-model="monetization"
                                                                    :items="['Monetized', 'Non-Monetized']"                 
                                                                    label="Monetization"                                                                                                                                                                                                                                                                                                                          
                                                                />
                                                            </v-col>
                                                            <v-col cols="12" md="4">
                                                                <v-select                                                                     
                                                                    v-model="owner"
                                                                    :items="networkOwnerOptions"                 
                                                                    label="Ownership"                                                                         
                                                                />
                                                            </v-col>
                                                            <v-col v-if="loggedInUser.user.role=='sysadmin' || loggedInUser.user.role=='admin'" cols="12" md="4">
                                                                <v-select  

                                                                    v-model="brand_lead"
                                                                    :items="brandLeadOptions"                 
                                                                    label="Brand Representative"         
                                                                    :clearable="true"                                                                                                                                                                                                                                                                                                                      
                                                                />
                                                            </v-col>                                                            
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <v-textarea
                                                                    outlined                                                            
                                                                    label="Description"
                                                                    v-model="description"                                                                                                                                    
                                                                />
                                                            </v-col>                                                        
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" md="6">
                                                                <v-select                                                                     
                                                                    v-model="priority"
                                                                    :items="priorityOptions"                 
                                                                    label="Priority"                                             
                                                                    :rules="requiredRules"
                                                                    :validate-on-blur="true"
                                                                    :clearable="true"       
                                                                    :messages="['(higher number = higher priority)']"               
                                                                />
                                                            </v-col>
                                                            <v-col cols="12" md="6">
                                                                <v-select                                                                                          
                                                                    v-model="cmpntimezone"
                                                                    :items="[ {text: 'UTC+02:00 (EET)', value: 'UTC+02:00'} ]"                 
                                                                    label="Timezone"                                             
                                                                    readonly
                                                                />
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" md="3">
                                                                <DatepickerPopup 
                                                                    v-model="startdate"
                                                                    label="Start Date"
                                                                    :rules="requiredRules"
                                                                ></DatepickerPopup>
                                                            </v-col>
                                                            <v-col cols="12" md="3">
                                                                <TimepickerPopup 
                                                                    v-model="starttime"
                                                                    label="Start Time"
                                                                    :rules="requiredRules"
                                                                ></TimepickerPopup>                                                                
                                                            </v-col>
                                                            <v-col cols="12" md="3">
                                                                <DatepickerPopup 
                                                                    v-model="enddate"
                                                                    label="End Date"
                                                                    :rules="[...requiredRules, v=> endDateLaterThanStart(v, endtime, startdate, starttime)]"
                                                                ></DatepickerPopup>
                                                            </v-col>
                                                            <v-col cols="12" md="3">
                                                                <TimepickerPopup 
                                                                    v-model="endtime"
                                                                    label="End Time"
                                                                    :rules="[...requiredRules, v=> endTimeLaterThanStart(v, enddate, startdate, starttime)]"
                                                                ></TimepickerPopup>                                                                
                                                            </v-col>                                                            
                                                        </v-row>
                                                    </v-col>
                                                    <v-col cols="12" md="3">
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <v-card>
                                                                    <!-- <v-card-title>Checkboxes - Array</v-card-title> -->                                                                
                                                                    <v-card-text>
                                                                        <p>Delivery Networks that will be targeted.</p>                                                                        
                                                                        <p v-if="filteredTargetNetworks == null || filteredTargetNetworks.length == 0 " style="font-style: italic" >(Select an owner that can target networks)</p>   
                                                                        <v-checkbox v-else v-for="networkOption in filteredTargetNetworks" :key="networkOption.value"
                                                                            class="mt-0 mb-0 pt-0 pb-0"                                                                                                                      
                                                                            v-model="targetnetworks"                                                                        
                                                                            :label="networkOption.text"
                                                                            :value="networkOption.value"
                                                                            :rules="arrayRequiredRules"
                                                                        />
                                                                    </v-card-text>
                                                                </v-card>
                                                            </v-col>                                                        
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                    </v-form>                                    
                                </v-tab-item>
                                <v-tab-item transition="false" :eager="true">
                                    <v-card flat>
                                        <v-card-text>
                                            <p>
                                                Here you can add the assets that are going to be displayed as ads for this Campaign
                                            </p>                                               
                                            <v-form v-model="assetCreateFormValid" ref="assetCreateForm">
                                                <div v-for="(asset, index) in assets" :key="asset.id" >
                                                    <div v-if="!asset.editMode"
                                                        class="eg-todo-item d-flex justify-space-between flex-wrap align-center white pa-4 rounded"
                                                    >
                                                        <div class="d-flex align-center">                                                        
                                                            <h6
                                                                class="ma-0"                                                            
                                                            >
                                                                #{{index+1}}
                                                            </h6>
                                                            <img v-if="getThumbnailType(asset) === 'external'" src="@/assets/images/file-types/External_60x60.jpg" alt="" width="60" class="ml-4" />
                                                            <img v-if="getThumbnailType(asset) === 'htmlbundle'" src="@/assets/images/file-types/HtmlZip_Icon_60x60.jpg" alt="" width="60" class="ml-4" />
                                                            <img v-if="getThumbnailType(asset) === 'normal'" :src="asset.thumbnailUrl" alt="" width="60" class="ml-4" />
                                                            <v-chip                                                                
                                                                class="mr-4 ml-4"
                                                                color="primary"
                                                                small                                                                
                                                            >
                                                                {{getSelectLabel(assetTypeOptions, asset.assetType)}}
                                                            </v-chip>
                                                            <h6
                                                                class="ma-0 ml-4"                                                            
                                                            >
                                                                {{asset.assetName}}
                                                            </h6>
                                                        </div>
                                                        <div class="">
                                                            <div>
                                                                <v-btn class="ml-2" @click="previewAsset(asset)" small>                                                                            
                                                                        Preview
                                                                </v-btn>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{on, attrs}">
                                                                        <v-btn icon class="ml-2" 
                                                                            @click="copyAssetUrl(asset)"
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                        >
                                                                            <v-icon>mdi-content-copy</v-icon>
                                                                        </v-btn>                                                                        
                                                                    </template>
                                                                    <span>Copy Asset Url</span>
                                                                </v-tooltip>

                                                                <v-btn icon class="ml-2" @click="clearAsset(asset)">                                                                       
                                                                        <v-icon>mdi-trash-can-outline</v-icon>
                                                                </v-btn>
                                                                
                                                                <v-btn icon class="ml-2" @click="editAsset(asset)">
                                                                    <v-icon>mdi-pencil-box-outline</v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr v-if="!asset.editMode" style="border-top: 1px solid lightgray;" />                                                
                                                    <v-card v-if="asset.editMode" class="mt-4">
                                                        <v-card-title>Asset #{{index+1}}</v-card-title>
                                                        <v-card-text class="pb-0">
                                                            <v-row>                                                        
                                                                <v-col cols="12" md="8">
                                                                    <div v-if="!asset.isExternal" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                                                                        <div v-if="asset.uploadResult && asset.uploadResult.success" style="display: flex; width: 100%; align-items: center;" class="pl-4">
                                                                            <div>
                                                                                <v-img v-if="asset.assetType !== 'htmlbundle' && !asset.isExternal" width="60" :src="asset.thumbnailUrl"></v-img>
                                                                                <v-img v-if="asset.assetType === 'htmlbundle'  && !asset.isExternal" width="60" src="@/assets/images/file-types/HtmlZip_Icon_60x60.jpg"></v-img>                                                                        
                                                                            </div>
                                                                            <div class="pl-4">
                                                                                <v-btn @click="clearAsset(asset)" :loading="assetSelectionInProgress" :disabled="assetSelectionInProgress" small outlined>   
                                                                                        <v-icon class="pr-2">mdi-trash-can-outline</v-icon>
                                                                                        Delete
                                                                                </v-btn>
                                                                            </div>  
                                                                            <div class="pl-4">
                                                                                <v-btn @click="openAssets(asset, index)" :loading="assetSelectionInProgress" :disabled="assetSelectionInProgress" small outlined>   
                                                                                        <v-icon class="pr-2">mdi-folder-outline</v-icon>
                                                                                        Select From Assets
                                                                                </v-btn>
                                                                            </div>
                                                                            <div class="pl-4">
                                                                                <!--<v-tooltip bottom>
                                                                                    <template v-slot:activator="{on,attrs}">

                                                                                <v-btn v-bind="attrs" v-on="on" @click="uploadAssetToProductMe(asset)" :loading="uploadingProductmeInProgress" :disabled="uploadingProductmeInProgress" small outlined>   
                                                                                        <v-icon class="pr-2">mdi-upload-circle-outline</v-icon>
                                                                                        PME Upload
                                                                                </v-btn>

                                                                                    </template>
                                                                            <span> {{ asset.pme_filename || "" }}</span>
                                                                                </v-tooltip>-->
                                                                            </div>     
                                                                            <div class="pl-4">                                                                                
                                                                                <!--<v-switch
                                                                                    v-model="asset.pme_activated"
                                                                                    label="Use PME Asset"
                                                                                />-->
                                                                            </div>                                                                                                                                                      
                                                                        </div>     
                                                                        <div v-if="asset.uploadResult && asset.uploadResult.success" style="display: flex; width: 100%; align-items: center;" class="pl-4">
                                                                            <div style="min-width: 60px;">
                                                                                
                                                                            </div>
                                                                            <div class="pl-4">
                                                                                <v-tooltip bottom>
                                                                                    <template v-slot:activator="{on,attrs}">

                                                                                <v-btn v-bind="attrs" v-on="on" @click="uploadAssetToProductMe(asset)" :loading="uploadingProductmeInProgress" :disabled="uploadingProductmeInProgress" small outlined>   
                                                                                        <v-icon class="pr-2">mdi-upload-circle-outline</v-icon>
                                                                                        PME Upload
                                                                                </v-btn>

                                                                                    </template>
                                                                            <span> {{ asset.pme_filename || "" }}</span>
                                                                                </v-tooltip>
                                                                            </div>                                                                              
                                                                            <div class="pl-4" >
                                                                                <v-tooltip bottom>
                                                                                    <template v-slot:activator="{on,attrs}">
                                                                                        <div v-bind="attrs" v-on="on">
                                                                                            <v-icon v-if="asset.pme_upload_success">mdi-information-slab-circle-outline</v-icon>
                                                                                            <v-icon color="red" v-if="asset.hasOwnProperty('pme_upload_success') && !asset.pme_upload_success">mdi-alert</v-icon>
                                                                                        </div>
                                                                                    </template>
                                                                                    <div v-if="asset.pme_upload_status"> <span class="mr-2 ml-2" v-for="t in asset.pme_upload_status" :key="t">{{ t }}</span> </div>
                                                                                </v-tooltip>                                                                                
                                                                            </div>
                                                                            <div class="pl-4 pr-4" style="min-width: 120px;">
                                                                                <v-switch
                                                                                    :disabled="!(asset.hasOwnProperty('pme_upload_status') && asset['pme_upload_status'] != null && Array.isArray(asset['pme_upload_status']) && asset['pme_upload_status'].length>0)"
                                                                                    v-model="asset.pme_activated"
                                                                                    label="Use PME Asset"
                                                                                />
                                                                            </div>     
                                                                            <div class="pl-4">                                                                                
                                                                                <v-select
                                                                                    v-model="asset.pme_target_networks"
                                                                                    width="400"
                                                                                    class="mt-4"
                                                                                    :items="networkOptions"
                                                                                    chips
                                                                                    label="Upload Target Networks"
                                                                                    multiple
                                                                                    small-chips
                                                                                    solo
                                                                                ></v-select>
                                                                            </div>                                                                                                                                                      
                                                                        </div>                                                             
                                                                        <div v-if="!(asset.uploadResult && asset.uploadResult.success)" style="width: 100%;">
                                                                            <v-file-input 
                                                                                type="file"
                                                                                enctype="multipart/form-data"
                                                                                name="assetfile"
                                                                                show-size 
                                                                                outlined 
                                                                                @change="(file) => { uploadFile(file, index) }"
                                                                                label="Click Here to upload a file"
                                                                                truncate-length="150"
                                                                                accept=".zip,.mp4,.mov,.mkv,.png,.gif,.jpeg,.jpg"
                                                                                >
                                                                            </v-file-input>
                                                                        </div>
                                                                        <div style="min-height: 4px; display: flex; flex-direction: column; align-items: center; justify-content: center;" class="w-full">
                                                                            <!-- <p class="mt-0 mb-0 pt-0 pb-0" style="color: green" v-if="asset.uploadResult && asset.uploadResult.success" >Asset Upload Completed Successfully</p> -->
                                                                            <p class="mt-0 mb-0 pt-0 pb-0" style="color: green" v-if="asset.uploadProgress != null && asset.uploadProgress < 100" >Uploading {{asset.uploadProgress}}%</p>
                                                                            <v-progress-linear
                                                                                v-if="asset.uploadProgress != null && asset.uploadProgress < 100" 
                                                                                v-model="asset.uploadProgress"
                                                                                color="green"
                                                                                :active="true"   
                                                                                stream                                                                     
                                                                            />
                                                                            <p class="mt-0 mb-0 pt-0 pb-0" style="color: green" v-if="asset.uploadProgress == 100">
                                                                                <v-progress-circular
                                                                                    :size="16"
                                                                                    :width="3"
                                                                                    color="green"
                                                                                    indeterminate
                                                                                    style="margin-top: -3px;"
                                                                                ></v-progress-circular>
                                                                                Analyzing Asset... Please wait. (Estimated Time Left: {{asset.analysisEstSecondsLeft}} seconds)
                                                                            </p>
                                                                            <v-progress-linear v-if="asset.uploadProgress == 100"
                                                                                value="0"
                                                                                buffer-value="0"
                                                                                color="green"                                                                                                                                               
                                                                                stream                                                     
                                                                            />
                                                                        </div>                                                  
                                                                        <p v-if="!asset.uploadResult.success && asset.uploadProgress == null" class="mt-0 mb-0 pt-0 pb-0" >or</p>                                                            
                                                                        <v-btn v-if="!asset.uploadResult.success && asset.uploadProgress == null"  @click="openAssets(asset, index)" :loading="assetSelectionInProgress" :disabled="assetSelectionInProgress"   dark color="secondary" style="min-width: 50%;" small>
                                                                                <v-icon class="pr-2">mdi-upload</v-icon>
                                                                                Load from Asset Library
                                                                        </v-btn>                                                                
                                                                    </div>    
                                                                    <div v-if="asset.isExternal" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                                                                        <div style="display: flex; width: 100%; align-items: center;" class="pl-4">
                                                                            <div>                                                                        
                                                                                <v-img width="60" src="@/assets/images/file-types/External_60x60.jpg"></v-img>
                                                                            </div>
                                                                            <div class="pl-4">

                                                                            </div>                                                                    
                                                                        </div>
                                                                    </div>                                                        
                                                                </v-col>                                                
                                                                <v-col cols="12" md="2">
                                                                    <v-select                                                                                                                                             
                                                                        v-model="asset.assetType"
                                                                        :items="assetTypeOptions"
                                                                        label="Asset Type"
                                                                        :rules="[(value)=> externalAssetSaveValidation(value, asset, 'assetType')]"
                                                                        :validate-on-blur="false"   
                                                                        :disabled="asset.uploadResult.success && !asset.isExternal"                                                             
                                                                    />
                                                                </v-col>
                                                                <v-col cols="12" md="2">
                                                                    <v-switch
                                                                        v-model="asset.isExternal"
                                                                        label="External Asset"
                                                                    />
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>                                                        
                                                                <v-col cols="12" >
                                                                    <v-text-field
                                                                        v-model="asset.assetUrl"                                                                
                                                                        :validate-on-blur="false" 
                                                                        label="Asset Source Url"
                                                                        prepend-icon="mdi-content-copy"
                                                                        append-outer-icon="mdi-content-copy"
                                                                        @click:prepend="copyAssetUrl(asset)"
                                                                        :readonly="!asset.isExternal"
                                                                        :rules="[(value)=> externalAssetSaveValidation(value, asset, 'assetUrl')]"
                                                                    >
                                                                        <template v-slot:append-outer>
                                                                            <v-btn @click="previewAsset(asset)" small>                                                                            
                                                                                    Preview
                                                                            </v-btn>
                                                                        </template>
                                                                    </v-text-field>
                                                                </v-col>                                                                                                        
                                                            </v-row>
                                                            <v-row>                                                        
                                                                <v-col cols="12" md="8">
                                                                    <v-text-field
                                                                        v-model="asset.assetName"                                                                        
                                                                        :validate-on-blur="false" 
                                                                        label="Asset Name"
                                                                        :rules="[(value)=> externalAssetSaveValidation(value, asset, 'assetName')]"
                                                                        :disabled="!asset.isExternal"
                                                                    />
                                                                </v-col>                                                
                                                                <v-col cols="12" md="4">
                                                                    <v-text-field
                                                                        v-model="asset.duration"                                                                                                                                
                                                                        label="Duration (Seconds)"
                                                                        :disabled="!asset.isExternal"
                                                                    />  
                                                                </v-col>
                                                            </v-row>                                                    
                                                            <v-row>                                                        
                                                                <v-col cols="12" md="8">
                                                                    <v-text-field
                                                                        v-show="!asset.isExternal"                                                                
                                                                        v-model="asset.storagePath"                                                                                                                                
                                                                        label="Storage Path"      
                                                                        disabled                                                                
                                                                    />
                                                                </v-col>                                                
                                                                <v-col cols="12" md="4">
                                                                    <v-select             
                                                                        v-show="!asset.isExternal"                                                        
                                                                        v-model="asset.storageTarget"
                                                                        :items="storageTargetOptions"
                                                                        label="Target Storage"  
                                                                        disabled                                                                    
                                                                    />
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>                                                        
                                                                <v-col cols="9" >
                                                                    <v-text-field
                                                                        v-model="asset.webTargetUrl"                                                                
                                                                        :validate-on-blur="false" 
                                                                        label="Web Target Url"
                                                                        prepend-icon="mdi-content-copy"
                                                                        append-outer-icon="mdi-content-copy"
                                                                        @click:prepend="copyWebTargetUrl(asset)"                                                                        
                                                                        :rules="[]"
                                                                    >
                                                                        <template v-slot:append-outer>
                                                                            <v-btn @click="previewAssetWebTarget(asset)" small>                                                                            
                                                                                    Preview
                                                                            </v-btn>
                                                                        </template>
                                                                    </v-text-field>
                                                                </v-col>
                                                                <v-col cols="3" >
                                                                    <v-select                                                                     
                                                                        v-model="asset.webTargetUrlBehaviour"
                                                                        :items="['New Window', 'Redirect']"                 
                                                                        label="Target Link Behaviour"                                                                                                                                                 
                                                                        :validate-on-blur="false" 
                                                                        :clearable="true"                      
                                                                    />
                                                                </v-col>                                                                                                        
                                                            </v-row>
                                                            <v-row>
                                                                <v-col cols="12">
                                                                    <v-card>
                                                                        <v-card-title>Mobile Asset                                                                          
                                                                        <div class="ml-4">
                                                                            <v-switch                                                                                
                                                                                v-model="asset.hasMobileAsset"
                                                                                label=" "
                                                                            />
                                                                        </div>
                                                                        </v-card-title>
                                                                        <v-card-text v-if="asset.hasMobileAsset">
                                                                            



















































                                                                            <v-row>                                                        
                                                                <v-col cols="12" md="8">
                                                                    <div v-if="!asset.mob_isExternal" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                                                                        <div v-if="asset.mob_uploadResult && asset.mob_uploadResult.success" style="display: flex; width: 100%; align-items: center;" class="pl-4">
                                                                            <div>
                                                                                <v-img v-if="asset.mob_assetType !== 'htmlbundle' && !asset.mob_isExternal" width="60" :src="asset.mob_thumbnailUrl"></v-img>
                                                                                <v-img v-if="asset.mob_assetType === 'htmlbundle'  && !asset.mob_isExternal" width="60" src="@/assets/images/file-types/HtmlZip_Icon_60x60.jpg"></v-img>                                                                        
                                                                            </div>
                                                                            <div class="pl-4">
                                                                                <v-btn @click="clearMobileAsset(asset)" small outlined>   
                                                                                        <v-icon class="pr-2">mdi-trash-can-outline</v-icon>
                                                                                        Delete
                                                                                </v-btn>
                                                                            </div>                                                                    
                                                                        </div>                                                                 
                                                                        <div v-if="!(asset.mob_uploadResult && asset.mob_uploadResult.success)" style="width: 100%;">
                                                                            <v-file-input 
                                                                                type="file"
                                                                                enctype="multipart/form-data"
                                                                                name="assetfile"
                                                                                show-size 
                                                                                outlined 
                                                                                @change="(file) => { uploadFile(file, index, true) }"
                                                                                label="Click Here to upload a file"
                                                                                truncate-length="150"
                                                                                accept=".zip,.mp4,.mov,.mkv,.png,.gif,.jpeg,.jpg"
                                                                                >
                                                                            </v-file-input>
                                                                        </div>
                                                                        <div style="min-height: 4px; display: flex; flex-direction: column; align-items: center; justify-content: center;" class="w-full">
                                                                            <!-- <p class="mt-0 mb-0 pt-0 pb-0" style="color: green" v-if="asset.uploadResult && asset.uploadResult.success" >Asset Upload Completed Successfully</p> -->
                                                                            <p class="mt-0 mb-0 pt-0 pb-0" style="color: green" v-if="asset.mob_uploadProgress != null && asset.mob_uploadProgress < 100" >Uploading {{asset.mob_uploadProgress}}%</p>
                                                                            <v-progress-linear
                                                                                v-if="asset.mob_uploadProgress != null && asset.mob_uploadProgress < 100" 
                                                                                v-model="asset.mob_uploadProgress"
                                                                                color="green"
                                                                                :active="true"   
                                                                                stream                                                                     
                                                                            />
                                                                            <p class="mt-0 mb-0 pt-0 pb-0" style="color: green" v-if="asset.mob_uploadProgress == 100">
                                                                                <v-progress-circular
                                                                                    :size="16"
                                                                                    :width="3"
                                                                                    color="green"
                                                                                    indeterminate
                                                                                    style="margin-top: -3px;"
                                                                                ></v-progress-circular>
                                                                                Analyzing Asset... Please wait. (Estimated Time Left: {{asset.mob_analysisEstSecondsLeft}} seconds)
                                                                            </p>
                                                                            <v-progress-linear v-if="asset.mob_uploadProgress == 100"
                                                                                value="0"
                                                                                buffer-value="0"
                                                                                color="green"                                                                                                                                               
                                                                                stream                                                     
                                                                            />
                                                                        </div>                                                  
                                                                        <p v-if="!asset.mob_uploadResult.success && asset.mob_uploadProgress == null" class="mt-0 mb-0 pt-0 pb-0" >or</p>                                                            
                                                                        <v-btn v-if="!asset.mob_uploadResult.success && asset.mob_uploadProgress == null" dark color="secondary" style="min-width: 50%;" small>
                                                                                <v-icon class="pr-2">mdi-upload</v-icon>
                                                                                Load from Asset Library
                                                                        </v-btn>                                                                
                                                                    </div>    
                                                                    <div v-if="asset.mob_isExternal" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                                                                        <div style="display: flex; width: 100%; align-items: center;" class="pl-4">
                                                                            <div>                                                                        
                                                                                <v-img width="60" src="@/assets/images/file-types/External_60x60.jpg"></v-img>
                                                                            </div>
                                                                            <div class="pl-4">

                                                                            </div>                                                                    
                                                                        </div>
                                                                    </div>                                                        
                                                                </v-col>                                                
                                                                <v-col cols="12" md="2">
                                                                    <v-select                                                                                                                                             
                                                                        v-model="asset.mob_assetType"
                                                                        :items="assetTypeOptions"
                                                                        label="Asset Type"
                                                                        :rules="[(value)=> externalAssetSaveValidation(value, asset, 'mob_assetType')]"
                                                                        :validate-on-blur="false"   
                                                                        :disabled="asset.mob_uploadResult.success && !asset.mob_isExternal"                                                             
                                                                    />
                                                                </v-col>
                                                                <v-col cols="12" md="2">
                                                                    <v-switch
                                                                        v-model="asset.mob_isExternal"
                                                                        label="External Asset"
                                                                    />
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>                                                        
                                                                <v-col cols="12" >
                                                                    <v-text-field
                                                                        v-model="asset.mob_assetUrl"                                                                
                                                                        :validate-on-blur="false" 
                                                                        label="Asset Source Url"
                                                                        prepend-icon="mdi-content-copy"
                                                                        append-outer-icon="mdi-content-copy"
                                                                        @click:prepend="copyAssetUrl(asset, true)"
                                                                        :readonly="!asset.mob_isExternal"
                                                                        :rules="[(value)=> externalAssetSaveValidation(value, asset, 'mob_assetUrl')]"
                                                                    >
                                                                        <template v-slot:append-outer>
                                                                            <v-btn @click="previewAsset(asset, true)" small>                                                                            
                                                                                    Preview
                                                                            </v-btn>
                                                                        </template>
                                                                    </v-text-field>
                                                                </v-col>                                                                                                        
                                                            </v-row>
                                                            <v-row>                                                        
                                                                <v-col cols="12" md="8">
                                                                    <v-text-field
                                                                        v-model="asset.mob_assetName"                                                                        
                                                                        :validate-on-blur="false" 
                                                                        label="Asset Name"
                                                                        :rules="[(value)=> externalAssetSaveValidation(value, asset, 'mob_assetName')]"
                                                                        :disabled="!asset.mob_isExternal"
                                                                    />
                                                                </v-col>                                                
                                                                <v-col cols="12" md="4">
                                                                    <v-text-field
                                                                        v-model="asset.mob_duration"                                                                                                                                
                                                                        label="Duration (Seconds)"
                                                                        :disabled="!asset.mob_isExternal"
                                                                    />  
                                                                </v-col>
                                                            </v-row>                                                    
                                                            <v-row>                                                        
                                                                <v-col cols="12" md="8">
                                                                    <v-text-field
                                                                        v-show="!asset.mob_isExternal"                                                                
                                                                        v-model="asset.mob_storagePath"                                                                                                                                
                                                                        label="Storage Path"      
                                                                        disabled                                                                
                                                                    />
                                                                </v-col>                                                
                                                                <v-col cols="12" md="4">
                                                                    <v-select             
                                                                        v-show="!asset.mob_isExternal"                                                        
                                                                        v-model="asset.mob_storageTarget"
                                                                        :items="storageTargetOptions"
                                                                        label="Target Storage"  
                                                                        disabled                                                                    
                                                                    />
                                                                </v-col>
                                                            </v-row>
                                                            <!-- <v-row>                                                        
                                                                <v-col cols="9" >
                                                                    <v-text-field
                                                                        v-model="asset.mob_webTargetUrl"                                                                
                                                                        :validate-on-blur="false" 
                                                                        label="Web Target Url"
                                                                        prepend-icon="mdi-content-copy"
                                                                        append-outer-icon="mdi-content-copy"
                                                                        @click:prepend="copyWebTargetUrl(asset, true)"                                                                        
                                                                        :rules="[]"
                                                                    >
                                                                        <template v-slot:append-outer>
                                                                            <v-btn @click="previewAssetWebTarget(asset, true)" small>                                                                            
                                                                                    Preview
                                                                            </v-btn>
                                                                        </template>
                                                                    </v-text-field>
                                                                </v-col>
                                                                <v-col cols="3" >
                                                                    <v-select                                                                     
                                                                        v-model="asset.mob_webTargetUrlBehaviour"
                                                                        :items="['New Window', 'Redirect']"                 
                                                                        label="Target Link Behaviour"                                                                                                                                                 
                                                                        :validate-on-blur="false" 
                                                                        :clearable="true"                      
                                                                    />
                                                                </v-col>                                                                                                        
                                                            </v-row> -->


























































                                                                        </v-card-text>
                                                                    </v-card>
                                                                </v-col> 
                                                            </v-row>
                                                            <v-row>
                                                                <v-col cols="12" class="d-flex justify-center">
                                                                    <v-btn dark color="primary" style="min-width: 50%;" @click="saveAsset(asset)">
                                                                            <v-icon class="pr-2">mdi-content-save</v-icon>
                                                                            Save Asset
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-text>
                                                    </v-card>                                                                                          
                                                </div>                                            
                                            </v-form>
                                            <v-btn dark color="primary" class="mt-2" style="width: 100%;" @click="addAsset">
                                                    <v-icon class="pr-2">mdi-plus-box</v-icon>
                                                    Add An Asset
                                            </v-btn>
                                                                                  
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item  transition="false" :eager="true">
                                    <v-card flat>
                                        <v-card-text>
                                            <p>
                                                Configure the delivery rules for this Campaign. These will be used to display the campaign content ads on the targeted networks.
                                                <br/>
                                                There should be at least one rule per targeted Network.
                                            </p>                                            
                                            <v-form v-model="deliveryRuleFormValid" ref="deliveryRuleForm">
                                                <div v-for="(deliveryRule, idxx) in deliveryrules" :key="deliveryRule.code">                                                    
                                                    <div v-if="!deliveryRule.editMode"
                                                        class="eg-todo-item d-flex justify-space-between flex-wrap align-center white pa-4 rounded"
                                                    >
                                                        <table class="w-full">
                                                            <colgroup>
                                                                <col style="width: 5%" />
                                                                <col style="width: 6%" />
                                                                <col style="width: 8%" />
                                                                <col style="width: 8%" />
                                                                <col style="width: 14%" />
                                                                <col style="width: 5%" />
                                                                <col style="width: 7%" />
                                                                <col style="width: 10%" />
                                                                <col style="width: 7%" />
                                                                <col style="width: 7%" />
                                                                <col style="width: 7%" />
                                                                <col style="width: 7%" />
                                                                <col style="width: 7%" />
                                                                <col style="width: 4%" />
                                                            </colgroup>
                                                            <thead class="pb-4" v-if="idxx == 0">
                                                                <tr style="font-weight: bold;" class="pb-4">
                                                                    <td>No.</td>
                                                                    <td>Asset</td>
                                                                    <td>Network</td>    
                                                                    <td>Cluster</td>                                                                
                                                                    <td>Targeting</td>    
                                                                    <td>Adpoints</td>                                                                    
                                                                    <td>Start</td>
                                                                    <td>End</td>                                                                    
                                                                    <td>Unit</td>
                                                                    <td>Units Purchased</td>
                                                                    <td>Initial Unit Cost</td>
                                                                    <td>Final Unit Cost</td>
                                                                    <td>Total Cost</td>
                                                                    <td></td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>#{{idxx + 1}}</td>
                                                                    <td>
                                                                        <div v-if="deliveryRule.asset != null" class="d-flex- align-center">
                                                                            <img v-if="getThumbnailType(getAssetById(deliveryRule.asset)) === 'external'" src="@/assets/images/file-types/External_60x60.jpg" alt="" width="60" />
                                                                            <img v-if="getThumbnailType(getAssetById(deliveryRule.asset)) === 'htmlbundle'" src="@/assets/images/file-types/HtmlZip_Icon_60x60.jpg" alt="" width="60"  />
                                                                            <img v-if="getThumbnailType(getAssetById(deliveryRule.asset)) === 'normal'" :src="getAssetById(deliveryRule.asset).thumbnailUrl" alt="" width="60"  />
                                                                            <br/>
                                                                            <v-chip                                                                
                                                                                class="mr-4"
                                                                                color="primary"
                                                                                small                                                                
                                                                            >
                                                                                {{getSelectLabel(assetTypeOptions, getAssetById(deliveryRule.asset).assetType)}}
                                                                            </v-chip>
                                                                            
                                                                        </div>      
                                                                        <!--<div>
                                                                            <span
                                                                                class="ma-0"                                                            
                                                                            >
                                                                                {{getAssetById(deliveryRule.asset) ? getAssetById(deliveryRule.asset).assetName : ''}}
                                                                            </span>
                                                                        </div>-->
                                                                    </td>
                                                                    <td>{{ getSelectLabel(networkOptions, deliveryRule.network)}}</td>                                                                    
                                                                    <td>{{ extractClusterName(deliveryRule) || '-' }}</td>
                                                                    <td><div class="d-flex justify-start mb-2 pr-1" v-for="cr in extractCriteriaDescription(deliveryRule)" :key="cr.name"><span>{{ cr.name }}{{ cr.operator }}</span>&nbsp;<span style="text-align: right;">{{ cr.value }}</span></div></td>
                                                                    <td>{{deliveryRule.totalAdpoints}}</td>                                                                    
                                                                    <td>{{  (deliveryRule.startdate ? formatDateLabel(deliveryRule.startdate) : '') + " " + formatTimeLabel(deliveryRule.starttime) }}</td>
                                                                    <td>{{  (deliveryRule.enddate ? formatDateLabel(deliveryRule.enddate) : '') + " " + formatTimeLabel(deliveryRule.endtime) }}</td>                                                                                                                                         
                                                                    <td>{{ extractUnitDescription(deliveryRule.eventType) || '-' }}</td>
                                                                    <td v-if="deliveryRule.offline_targets" >{{(deliveryRule.calc_duration_days || 0) * (deliveryRule.totalAdpoints || 0) }}</td> <td v-else>{{deliveryRule.eventAmountGoal}}</td>
                                                                    <td>{{ formatEuro(deliveryRule.initialMediaCost_PerUnit) }}</td>
                                                                    <td>{{ formatEuro(deliveryRule.finalMediaCost_PerUnit) }}</td>
                                                                    <td>{{ formatEuro(deliveryRule.finalMediaCost_Total) }}</td>
                                                                    <td>
                                                                        <v-btn icon class="ml-2" @click="deleteDeliveryRule(idxx)">
                                                                            <v-icon>mdi-trash-can-outline</v-icon>
                                                                        </v-btn>
                                                                        <v-btn icon class="ml-2" @click="editDeliveryRule(deliveryRule, idxx)">
                                                                            <v-icon>mdi-pencil-box-outline</v-icon>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>                                                                    
                                                            </tbody>
                                                        </table>
                                                        
                                                    </div>
                                                    <hr v-if="!deliveryRule.editMode" style="border-top: 1px solid lightgray;" />
                                                    <v-card v-if="deliveryRule.editMode" class="mt-4">
                                                        <v-card-title>
                                                            <span>Delivery Rule #{{idxx+1}} </span>
                                                            <v-btn @click="deleteDeliveryRule(idxx)" small outlined class="ml-4">   
                                                                    <v-icon class="pr-2">mdi-trash-can-outline</v-icon>
                                                                    Delete
                                                            </v-btn>
                                                            <span v-if="deliveryRule.offline_targets" class="offlinetargets ml-4" > <v-icon class="pr-2">mdi-cloud-off-outline</v-icon> Offline Placement Targets </span>
                                                            <!--<v-checkbox
                                                                class="mt-0"
                                                                style="margin-left: 40px;"
                                                                v-model="deliveryRule.offline_targets"
                                                                label="Offline Placement Targets"                                                 
                                                                hide-details="true"    
                                                                readonly         
                                                                @change="onCompleteDeliveryRuleCondition(idxx)"                                                           
                                                            />-->
                                                        </v-card-title>
                                                        <v-card-text class="pb-0">
                                                            <v-row>
                                                                <v-col cols="12" md="4">
                                                                    <v-select
                                                                        :prepend-icon="isNetworkSelectionLockedForRule(deliveryRule) ? 'mdi-lock' : ''"
                                                                        :items="selectedNetworkOptions"
                                                                        v-model="deliveryRule.network"
                                                                        label="Network"
                                                                        :rules="requiredRules"
                                                                        dense
                                                                        outlined
                                                                        :readonly="isNetworkSelectionLockedForRule(deliveryRule)"
                                                                        @click="onAttemptNetworkChange(idxx)"
                                                                        @change="onDeliveryRuleNetworkChanged(idxx)"
                                                                        :messages="isNetworkSelectionLockedForRule(deliveryRule) ? ['This network is locked, while current Cluster Criteria filter is commited. Edit the Cluster to select another network'] : []"
                                                                        
                                                                    />                                                                    
                                                                </v-col>
                                                                <v-col cols="12" md="2">                                                                      
                                                                    <base-card>
                                                                        <v-list-item three-line>
                                                                            <v-list-item-content>
                                                                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                                                                <div class="body-2 mb-0 text--disabled">
                                                                                    Total
                                                                                </div>
                                                                                <v-list-item-title
                                                                                    class="headline mb-1 font-weight-bold"
                                                                                    >
                                                                                    {{ (deliveryRule.totalAdpoints == null || deliveryRule.calcInProgress ? '-' : deliveryRule.totalAdpoints) }}                                                                                    
                                                                                    </v-list-item-title
                                                                                >
                                                                                <v-list-item-subtitle>
                                                                                    <div class="d-flex flex-wrap">
                                                                                        <span class="font-weight-bold text-info"
                                                                                            >Targeted Adpoints  {{ (deliveryRule.calcInProgress ? '(Calculating...)' : '')}}</span
                                                                                        >
                                                                                    </div>
                                                                                </v-list-item-subtitle>
                                                                            </v-list-item-content>
                                                                        </v-list-item>
                                                                        <v-progress-linear
                                                                            :active="deliveryRule.calcInProgress"
                                                                            :indeterminate="deliveryRule.calcInProgress"
                                                                            absolute
                                                                            bottom
                                                                            color="deep-purple accent-4"
                                                                        />
                                                                    </base-card>                                                                  
                                                                </v-col>
                                                                <v-col cols="12" md="3">
                                                                    <base-card>
                                                                        <v-list-item three-line>
                                                                            <!--<v-list-item-content>                                                                                
                                                                                <div class="body-2 mb-0 text--disabled">
                                                                                    Available Capacity {{ (deliveryRule.capacityCalcInProgress ? '(Calculating...)' : '')}}
                                                                                </div>
                                                                                <v-list-item-title class="headline mb-1 font-weight-bold">                                                                                         
                                                                                        <span >{{ (deliveryRule.capacityCalcInProgress || deliveryRule.availableCapacity == null ? '-' : 0) }}</span>
                                                                                </v-list-item-title>
                                                                                <v-list-item-subtitle>
                                                                                    <div class="d-flex flex-wrap">                                                                                                                                                                                
                                                                                        <span class="font-weight-bold text-info">
                                                                                            error: No cache entries                                                                                            
                                                                                        </span>
                                                                                    </div>
                                                                                </v-list-item-subtitle>
                                                                            </v-list-item-content> --> 
                                                                            
                                                                            <v-list-item-content>                                                                                
                                                                                <div class="body-2 mb-0 text--disabled">
                                                                                    Available Capacity {{ (deliveryRule.capacityCalcInProgress ? '(Calculating...)' : '')}}
                                                                                </div>
                                                                                <v-list-item-title class="headline mb-1 font-weight-bold">                                                                                         
                                                                                        <span >{{ (deliveryRule.capacityCalcInProgress || deliveryRule.availableCapacity == null ? '-' : formatInteger(deliveryRule.availableCapacity)) }} {{ deliveryRule.offline_targets ? 'Daily Placements' : 'Impressions'  }}</span>
                                                                                </v-list-item-title>
                                                                                <v-list-item-subtitle>
                                                                                    <div class="d-flex flex-wrap">                                                                                                                                                                                
                                                                                        <span class="font-weight-bold text-info">
                                                                                            Out of {{ (deliveryRule.capacityCalcInProgress || deliveryRule.totalCapacity == null ? '-' : formatInteger(deliveryRule.totalCapacity)) }} 
                                                                                        </span>
                                                                                    </div>
                                                                                </v-list-item-subtitle>
                                                                            </v-list-item-content> 

                                                                            <apexchart v-if="!deliveryRule.capacityCalcInProgress && deliveryRule.availableCapacity != null && deliveryRule.totalCapacity != null && deliveryRule.totalCapacity != 0"
                                                                                width="80"
                                                                                height="110"
                                                                                type="radialBar"
                                                                                :options="chartOptions"
                                                                                :series="[ Math.ceil((deliveryRule.availableCapacity / deliveryRule.totalCapacity) * 100)]"
                                                                            />
                                                                        </v-list-item>
                                                                        <v-progress-linear
                                                                            :active="deliveryRule.capacityCalcInProgress"
                                                                            :indeterminate="deliveryRule.capacityCalcInProgress"
                                                                            absolute
                                                                            bottom
                                                                            color="deep-purple accent-4"
                                                                        />
                                                                    </base-card>
                                                                </v-col>
                                                                <v-col cols="12" md="2">                                                                      
                                                                    <base-card>
                                                                        <v-list-item three-line>
                                                                            <v-list-item-content>
                                                                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                                                                <div class="body-2 mb-0 text--disabled">
                                                                                    Total
                                                                                </div>
                                                                                <v-list-item-title
                                                                                    class="headline mb-1 font-weight-bold"
                                                                                    >
                                                                                    {{ formatEuro(deliveryRule.finalMediaCost_Total) }}                                                                                    
                                                                                    </v-list-item-title
                                                                                >
                                                                                <v-list-item-subtitle>
                                                                                    <div class="d-flex flex-wrap">
                                                                                        <span class="font-weight-bold text-info"
                                                                                            >Media Cost  {{ (deliveryRule.calcInProgress ? '(Calculating...)' : '')}}</span
                                                                                        >
                                                                                    </div>
                                                                                </v-list-item-subtitle>
                                                                            </v-list-item-content>
                                                                        </v-list-item>
                                                                        <v-progress-linear
                                                                            :active="deliveryRule.calcInProgress"
                                                                            :indeterminate="deliveryRule.calcInProgress"
                                                                            absolute
                                                                            bottom
                                                                            color="deep-purple accent-4"
                                                                        />
                                                                    </base-card>                                                                  
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col cols="12" md="4">
                                                                    <v-select
                                                                        :items="assets"
                                                                        v-model="deliveryRule.asset"
                                                                        item-text="assetName"
                                                                        item-value="id"
                                                                        label="Asset"
                                                                        dense
                                                                        outlined
                                                                        :rules="is_proposal ? [] : requiredRules"
                                                                        @change="onCompleteDeliveryRuleCondition(idxx)"
                                                                    >
                                                                        <template v-slot:selection="data">                                                                            
                                                                            <img v-if="getThumbnailType(data.item) === 'external'" src="@/assets/images/file-types/External_60x60.jpg" alt="" width="60" class="ml-4" />
                                                                            <img v-if="getThumbnailType(data.item) === 'htmlbundle'" src="@/assets/images/file-types/HtmlZip_Icon_60x60.jpg" alt="" width="60" class="ml-4" />
                                                                            <img v-if="getThumbnailType(data.item) === 'normal'" :src="data.item.thumbnailUrl" alt="" width="60" class="ml-4" />
                                                                            <v-chip                                                                
                                                                                class="mr-4 ml-4"
                                                                                color="primary"
                                                                                small                                                                
                                                                            >
                                                                                {{getSelectLabel(assetTypeOptions, data.item.assetType)}}
                                                                            </v-chip>
                                                                            <h6
                                                                                class="ma-0 ml-4" 
                                                                                style="overflow: hidden; line-break: anywhere;"                                                           
                                                                            >
                                                                                {{data.item.assetName}}
                                                                            </h6>                                                                            
                                                                        </template>
                                                                        <template v-slot:item="data">                                                                            
                                                                            <img v-if="getThumbnailType(data.item) === 'external'" src="@/assets/images/file-types/External_60x60.jpg" alt="" width="60" class="ml-4" />
                                                                            <img v-if="getThumbnailType(data.item) === 'htmlbundle'" src="@/assets/images/file-types/HtmlZip_Icon_60x60.jpg" alt="" width="60" class="ml-4" />
                                                                            <img v-if="getThumbnailType(data.item) === 'normal'" :src="data.item.thumbnailUrl" alt="" width="60" class="ml-4" />
                                                                            <v-chip                                                                
                                                                                class="mr-4 ml-4"
                                                                                color="primary"
                                                                                small                                                                
                                                                            >
                                                                                {{getSelectLabel(assetTypeOptions, data.item.assetType)}}
                                                                            </v-chip>
                                                                            <h6
                                                                                class="ma-0 ml-4"    
                                                                                style="overflow: hidden; line-break: anywhere;"                                                           
                                                                            >
                                                                                {{data.item.assetName}}
                                                                            </h6>                                                                            
                                                                        </template>
                                                                    </v-select>
                                                                </v-col>
                                                                <v-col cols="12" md="2">    
                                                                    <base-card>
                                                                        <v-list-item three-line>
                                                                            <v-list-item-content>
                                                                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                                                                <div class="body-2 mb-0 text--disabled">
                                                                                    Duration
                                                                                </div>
                                                                                <v-list-item-title
                                                                                    class="headline mb-1 font-weight-bold"
                                                                                    >
                                                                                    {{ (deliveryRule.calc_duration_days && !deliveryRule.calcInProgress ? deliveryRule.calc_duration_days : '-') }}
                                                                                    </v-list-item-title
                                                                                >
                                                                                <v-list-item-subtitle>
                                                                                    <div class="d-flex flex-wrap">
                                                                                        <span class="font-weight-bold text-info"
                                                                                            >Days {{ (deliveryRule.calcInProgress ? '(Calculating...)' : '')}}</span
                                                                                        >
                                                                                    </div>
                                                                                </v-list-item-subtitle>
                                                                            </v-list-item-content>
                                                                        </v-list-item>
                                                                        <v-progress-linear
                                                                            :active="deliveryRule.calcInProgress"
                                                                            :indeterminate="deliveryRule.calcInProgress"
                                                                            absolute
                                                                            bottom
                                                                            color="deep-purple accent-4"
                                                                        />
                                                                    </base-card>                                                                
                                                                </v-col>
                                                                <v-col cols="12" md="3">                                                                     
                                                                    <base-card>
                                                                        <v-list-item v-if="!deliveryRule.offline_targets" three-line>
                                                                            <v-list-item-content>
                                                                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                                                                <div class="body-2 mb-0 text--disabled">
                                                                                     Estimated Avg
                                                                                </div>                                                                                                                                                                
                                                                                <v-list-item-title class="headline mb-1 font-weight-bold">
                                                                                    {{ (deliveryRule.network && !deliveryRule.calcInProgress ?  formatInteger(deliveryRule.calc_event_target_daily_total) : '-') }} Impressions
                                                                                    <span  style="display: none;">{{ (deliveryRule.totalAdpoints == null ? '-' : deliveryRule.totalAdpoints) }} Impressions</span>
                                                                                </v-list-item-title>
                                                                                <v-list-item-subtitle>
                                                                                    <div class="d-flex flex-wrap">
                                                                                        <span class="font-weight-bold text-info">
                                                                                            Daily Target {{ (deliveryRule.calcInProgress ? '(Calculating...)' : '')}}
                                                                                        </span>
                                                                                    </div>
                                                                                </v-list-item-subtitle>
                                                                            </v-list-item-content>
                                                                        </v-list-item>
                                                                        <v-list-item v-else three-line>
                                                                            <v-list-item-content>
                                                                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                                                                <div class="body-2 mb-0 text--disabled">
                                                                                     Estimated
                                                                                </div>                                                                                                                                                                
                                                                                <v-list-item-title class="headline mb-1 font-weight-bold">
                                                                                    {{ (deliveryRule.offline_data && deliveryRule.offline_data.allConflicts != null) ? deliveryRule.offline_data.allConflicts.length : 0 }} Conflicts
                                                                                    <span  style="display: none;">{{ (deliveryRule.totalAdpoints == null ? '-' : deliveryRule.totalAdpoints) }} {{(deliveryRule.eventType === 'customevent' ? '"' + (deliveryRule.customEventName ? deliveryRule.customEventName : '') + '" Events' : getSelectLabel(eventTypeOptions, deliveryRule.eventType))   }}</span>
                                                                                </v-list-item-title>
                                                                                <v-list-item-subtitle>
                                                                                    <div class="d-flex flex-wrap">
                                                                                        <!--<v-btn x-small color="black" dark>Show Conflicts</v-btn>-->
                                                                                        <!--<span class="font-weight-bold text-info">
                                                                                            Daily Target {{ (deliveryRule.calcInProgress ? '(Calculating...)' : '')}}
                                                                                        </span>-->
                                                                                    </div>
                                                                                </v-list-item-subtitle>
                                                                            </v-list-item-content>
                                                                        </v-list-item>
                                                                        
                                                                        <v-progress-linear
                                                                            :active="deliveryRule.calcInProgress"
                                                                            :indeterminate="deliveryRule.calcInProgress"
                                                                            absolute
                                                                            bottom
                                                                            color="deep-purple accent-4"
                                                                        />
                                                                    </base-card> 
                                                                </v-col>
                                                                <v-col cols="12" md="2">                                                                      
                                                                    <base-card>
                                                                        <v-list-item three-line>
                                                                            <v-list-item-content>
                                                                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                                                                <div class="body-2 mb-0 text--disabled">
                                                                                    Per Unit
                                                                                </div>
                                                                                <v-list-item-title
                                                                                    class="headline mb-1 font-weight-bold"
                                                                                    >
                                                                                    {{ formatEuro(deliveryRule.finalMediaCost_PerUnit) }}                                                                                    
                                                                                    </v-list-item-title
                                                                                >
                                                                                <v-list-item-subtitle>
                                                                                    <div class="d-flex flex-wrap">
                                                                                        <span class="font-weight-bold text-info"
                                                                                            >Media Cost  {{ (deliveryRule.calcInProgress ? '(Calculating...)' : '')}}</span
                                                                                        >
                                                                                    </div>
                                                                                </v-list-item-subtitle>
                                                                            </v-list-item-content>
                                                                        </v-list-item>
                                                                        <v-progress-linear
                                                                            :active="deliveryRule.calcInProgress"
                                                                            :indeterminate="deliveryRule.calcInProgress"
                                                                            absolute
                                                                            bottom
                                                                            color="deep-purple accent-4"
                                                                        />
                                                                    </base-card>                                                                  
                                                                </v-col>
                                                            </v-row>
                                                            <!--<v-row v-if="deliveryRule.offline_targets && (deliveryRule.offline_data != null) && (deliveryRule.offline_data.conflictEvents != null)">
                                                                <v-col cols="12" md="4">&nbsp;</v-col>
                                                                <v-col cols="12" md="3">
                                                                    <v-date-picker                                                                        
                                                                        :events="deliveryRule.offline_data.conflictEvents"
                                                                        @change="(prm1) => { offlineDateSelected(prm1, idxx) }"
                                                                        event-color="red"
                                                                    ></v-date-picker>
                                                                </v-col>
                                                                <v-col cols="12" md="5">
                                                                    <v-simple-table height="300">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Adpoint</th>
                                                                                <th>Campaign</th>                                                                                
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody v-if="!deliveryRule.offline_data.selectedDate" class="tinytablelist">
                                                                            <tr>
                                                                                <td class="nobottomborder"> Select A Date</td>
                                                                                <td class="nobottomborder"></td>
                                                                            </tr>
                                                                        </tbody>
                                                                        <tbody v-else-if="deliveryRule.offline_data.conflicts && deliveryRule.offline_data.conflicts.length>0" class="tinytablelist">
                                                                            <tr  v-for="tl in deliveryRule.offline_data.conflicts" :key="tl.adpoint + '_' + idxx">
                                                                                <td class="nobottomborder"> {{ tl.adpoint }}</td>
                                                                                <td class="nobottomborder"> {{ tl.campaign }}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                        <tbody v-else class="tinytablelist">
                                                                            <tr>
                                                                                <td class="nobottomborder"> No Conflicts on {{ deliveryRule.offline_data.selectedDate }}</td>
                                                                                <td class="nobottomborder"></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </v-simple-table>
                                                                </v-col>
                                                            </v-row>-->
                                                            <v-row>
                                                                <v-col cols="12" md="12">                 
                                                                        <v-alert type="warning" v-if="deliveryRule.warninmsg">
                                                                            {{deliveryRule.warninmsg}}
                                                                        </v-alert>                                                   
                                                                        <v-tabs>
                                                                            <v-tab>
                                                                                Filtering 
                                                                                <v-icon class="pl-2" v-if="!deliveryRule.filteringTabValid">mdi-alert-circle</v-icon>
                                                                            </v-tab>                                                                            
                                                                            <v-tab>
                                                                                Goal
                                                                                <v-icon class="pl-2" v-if="!deliveryRule.goalTabValid">mdi-alert-circle</v-icon>
                                                                            </v-tab>
                                                                            <v-tab>
                                                                                Time Windows
                                                                            </v-tab>
                                                                            <v-tab>
                                                                                Tags                                                                                
                                                                            </v-tab>
                                                                            <v-tab-item transition="true">                                                                                
                                                                                <v-alert type="error" class="mt-2 mb-0" v-if="deliveryRule.errormsg">
                                                                                    {{deliveryRule.errormsg}}
                                                                                </v-alert>
                                                                                <div class="criteria-guard-wrapper">
                                                                                    <advanced-grid-filters-list 
                                                                                        :dynamic="true"                         
                                                                                        :horizontalRendering="true"                                                             
                                                                                        v-model="deliveryRule.filterfields" 
                                                                                        @search="onSearch" 
                                                                                        :searchButtonVisible="false"                                                                                     
                                                                                        @delete="({index, nameToDelete}) => {onDeleteCondition(idxx, {orIndex: index, nameToDelete}); }" 
                                                                                        @deleteor="(orIndex) => {onDeleteOrCondition(idxx, orIndex);}" 
                                                                                        :ref="(el) => { advancedfilter[idxx]; }"
                                                                                        @addcriteria="({attributeToAdd, orClauseIndex}) => { onAddDeliveryRuleFiltCondition(idxx, {attributeToAdd, orClauseIndex}) }"
                                                                                        :attributeOptions="getScopedAttributeOptions(idxx)"
                                                                                        @complete="() => { onDeliveryRuleCriteriaCompleted(idxx) }"
                                                                                    />
                                                                                    <div
                                                                                        v-if="!canEditDeliveryRuleCriteria(idxx, false)"
                                                                                        class="criteria-guard-overlay"
                                                                                        @click="onAttemptCriteriaEdit(idxx)"
                                                                                    ></div>
                                                                                </div>
                                                                                <v-btn class="d-flex mt-2" style="width: 100%;" small color="black" dark @click="() => {addOrClause(idxx);}" >
                                                                                    Add "OR" Cond.
                                                                                </v-btn>   
                                                                            </v-tab-item>
                                                                            <v-tab-item transition="true" :eager="true">
                                                                                <v-row>
                                                                                    <v-col cols="12" md="4">
                                                                                        <v-row>
                                                                                            <v-col cols="6">
                                                                                                <v-select                                                                     
                                                                                                    v-model="deliveryRule.eventType"
                                                                                                    :items="getEventTypeOptionsForRule(idxx)"                 
                                                                                                    label="Event Type"                                                                                                                                                                                                                                     
                                                                                                    :rules="requiredRules"
                                                                                                    :validate-on-blur="false"     
                                                                                                    @change="onCompleteDeliveryRuleCondition(idxx)"                                                                                                                
                                                                                                />
                                                                                            </v-col>
                                                                                            <v-col cols="6">
                                                                                                <v-text-field
                                                                                                    v-if="deliveryRule.eventType === 'customevent'"
                                                                                                    v-model="deliveryRule.customEventName"                                                                                                    
                                                                                                    :rules="[...(deliveryRule.eventType === 'customevent' ? requiredRules : [])]"
                                                                                                    :validate-on-blur="false" 
                                                                                                    label="Custom Event Name"
                                                                                                />
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                        <v-row>
                                                                                            <v-col cols="6">
                                                                                                <DatepickerPopup 
                                                                                                    v-model="deliveryRule.startdate"
                                                                                                    label="Start Date"
                                                                                                    :rules="requiredRules"                                                                                                    
                                                                                                    @input="onCompleteDeliveryRuleCondition(idxx)"
                                                                                                ></DatepickerPopup>
                                                                                            </v-col>
                                                                                            
                                                                                            <v-col cols="6">
                                                                                                <DatepickerPopup 
                                                                                                    v-model="deliveryRule.enddate"
                                                                                                    label="End Date"
                                                                                                    :rules="[...requiredRules, v=> endDateLaterThanStart(v, deliveryRule.endtime, deliveryRule.startdate, deliveryRule.starttime)]"
                                                                                                    @input="onCompleteDeliveryRuleCondition(idxx)"
                                                                                                ></DatepickerPopup>
                                                                                            </v-col>
                                                                                            
                                                                                        </v-row>
                                                                                        <v-row>
                                                                                            <v-col cols="6">
                                                                                                <TimepickerPopup 
                                                                                                    v-model="deliveryRule.starttime"
                                                                                                    label="Start Time"
                                                                                                    :rules="requiredRules"
                                                                                                    @input="onCompleteDeliveryRuleCondition(idxx)"
                                                                                                ></TimepickerPopup>
                                                                                            </v-col>
                                                                                            <v-col cols="6">
                                                                                                <TimepickerPopup 
                                                                                                    v-model="deliveryRule.endtime"
                                                                                                    label="End Time"
                                                                                                    :rules="[...requiredRules, v=> endTimeLaterThanStart(v, deliveryRule.enddate, deliveryRule.startdate, deliveryRule.starttime)]"
                                                                                                    @input="onCompleteDeliveryRuleCondition(idxx)"
                                                                                                ></TimepickerPopup>
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                    </v-col>
                                                                                    <v-col cols="12" md="4" v-if="!deliveryRule.offline_targets">                                                                                        
                                                                                        <v-row>
                                                                                            <v-col cols="6">
                                                                                                <v-text-field
                                                                                                    type="number"
                                                                                                    v-model.number="deliveryRule.eventAmountGoal"
                                                                                                    :rules="requiredRules"
                                                                                                    :validate-on-blur="false" 
                                                                                                    label="Units Purchased"
                                                                                                    @change="onCompleteDeliveryRuleCondition(idxx)"
                                                                                                />
                                                                                            </v-col>

                                                                                            <v-col cols="6">
                                                                                                <v-text-field
                                                                                                    type="number"
                                                                                                    v-model.number="deliveryRule.initialMediaCost_PerUnit"      
                                                                                                    prepend-inner-icon="mdi-lock"                                                                                              
                                                                                                    readonly
                                                                                                    label="Initial Media Unit Cost"                                                                                                    
                                                                                                />
                                                                                                <!--<v-select                                                                     
                                                                                                    v-model="deliveryRule.timeframe"
                                                                                                    :items="['In Total', 'Per Day']"                 
                                                                                                    label="Goal Timeframe"                                                                                                                                                 
                                                                                                    :validate-on-blur="false" 
                                                                                                    :clearable="true"                      
                                                                                                />-->
                                                                                            </v-col>                                                                                            
                                                                                        </v-row>
                                                                                        <v-row>
                                                                                            <v-col cols="6">
                                                                                                <v-text-field
                                                                                                    type="number"
                                                                                                    v-model.number="deliveryRule.dailyFrequencyCap"
                                                                                                    :rules="numberRequiredRules"
                                                                                                    :validate-on-blur="false" 
                                                                                                    label="Daily Limit"
                                                                                                    @change="onCompleteDeliveryRuleCondition(idxx)"
                                                                                                />
                                                                                            </v-col>

                                                                                            <v-col cols="6">
                                                                                                <!--<v-text-field
                                                                                                    type="number"
                                                                                                    v-model.number="deliveryRule.hourlyFrequencyCap"                                                                                                    
                                                                                                    :validate-on-blur="false" 
                                                                                                    label="Hourly Limit"                                                                                                    
                                                                                                />-->
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                    </v-col>
                                                                                    <v-col cols="12" :md=" deliveryRule.offline_targets ? '8' : '4' ">
                                                                                        <v-row>
                                                                                            <v-col cols="6">
                                                                                                <v-text-field
                                                                                                    v-if="deliveryRule.overrideMediaUnitCost"
                                                                                                    type="number"
                                                                                                    v-model.number="deliveryRule.manualFinalMediaCost_PerUnit"  
                                                                                                    prepend-inner-icon="mdi-lock-percent-open-variant"                                                                                                    
                                                                                                    @change="onCompleteDeliveryRuleCondition(idxx)"
                                                                                                    label="Final Media Unit Cost"                                                                                                    
                                                                                                />
                                                                                                <v-text-field
                                                                                                    v-else
                                                                                                    type="number"
                                                                                                    v-model.number="deliveryRule.proposedFinalMediaCost_PerUnit"  
                                                                                                    prepend-inner-icon="mdi-lock-percent"
                                                                                                    readonly
                                                                                                    @change="onCompleteDeliveryRuleCondition(idxx)"
                                                                                                    label="Final Media Unit Cost"                                                                                                    
                                                                                                />
                                                                                                <!--<v-select                                                                     
                                                                                                    v-model="deliveryRule.timeframe"
                                                                                                    :items="['In Total', 'Per Day']"                 
                                                                                                    label="Goal Timeframe"                                                                                                                                                 
                                                                                                    :validate-on-blur="false" 
                                                                                                    :clearable="true"                      
                                                                                                />-->
                                                                                            </v-col>
                                                                                            <!--<v-col cols="6">
                                                                                                
                                                                                                <v-select                                                                     
                                                                                                    v-model="deliveryRule.targetingdistribution"
                                                                                                    :items="['Per Adpoint', 'All Adpoints']"                 
                                                                                                    label="Adpoint Distribution"                                                                                                                                                 
                                                                                                    :validate-on-blur="false" 
                                                                                                    :clearable="true"                      
                                                                                                />
                                                                                            </v-col>-->
                                                                                            <v-col cols="6">
                                                                                                <v-checkbox v-model="deliveryRule.overrideMediaUnitCost" label="Override Unit Cost" @change="resetOverrideMediaUnitCost(deliveryRule, idxx)"></v-checkbox>
                                                                                                <!--<v-select                                                                     
                                                                                                    v-model="deliveryRule.timebaseddistribution"
                                                                                                    :items="['No Pacing', 'Spaced Evenly', 'Front Loaded']"                 
                                                                                                    label="Time Distribution"                                                                                                                                                 
                                                                                                    :validate-on-blur="false" 
                                                                                                    :clearable="true"                      
                                                                                                />-->
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                        <v-row v-if="deliveryRule.offline_targets && (deliveryRule.offline_data != null) && (deliveryRule.offline_data.conflictEvents != null)">
                                                                                            <v-col cols="5">       
                                                                                                <v-date-picker                                                                        
                                                                                                    :events="deliveryRule.offline_data.conflictEvents"
                                                                                                    @change="(prm1) => { offlineDateSelected(prm1, idxx) }"
                                                                                                    event-color="red"
                                                                                                ></v-date-picker>                                                                                         
                                                                                                <!--<v-select                                                                     
                                                                                                    v-model="deliveryRule.allocationmode"
                                                                                                    :items="['Absolute', 'Relative']"                 
                                                                                                    label="Capacity Allocation Mode"                                                                                                                                                 
                                                                                                    :validate-on-blur="false" 
                                                                                                    :clearable="true"                      
                                                                                                />-->
                                                                                            </v-col>
                                                                                            <v-col cols="7">
                                                                                                <v-simple-table height="300">
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th>Adpoint</th>
                                                                                                            <th>Campaign</th>                                                                                
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody v-if="!deliveryRule.offline_data.selectedDate" class="tinytablelist">
                                                                                                        <tr>
                                                                                                            <td class="nobottomborder"> Select A Date</td>
                                                                                                            <td class="nobottomborder"></td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                    <tbody v-else-if="deliveryRule.offline_data.conflicts && deliveryRule.offline_data.conflicts.length>0" class="tinytablelist">
                                                                                                        <tr  v-for="tl in deliveryRule.offline_data.conflicts" :key="tl.adpoint + '_' + idxx">
                                                                                                            <td class="nobottomborder"> {{ tl.adpoint }}</td>
                                                                                                            <td class="nobottomborder"> {{ tl.campaign }}</td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                    <tbody v-else class="tinytablelist">
                                                                                                        <tr>
                                                                                                            <td class="nobottomborder"> No Conflicts on {{ deliveryRule.offline_data.selectedDate }}</td>
                                                                                                            <td class="nobottomborder"></td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </v-simple-table>
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                        <v-row v-else>
                                                                                            <v-col cols="6">

                                                                                            </v-col>
                                                                                        </v-row>
                                                                                    </v-col>
                                                                                </v-row>
                                                                                
                                                                            </v-tab-item>
                                                                            <v-tab-item transition="true">
                                                                                <v-row>
                                                                                    <v-col cols="12">
                                                                                        <v-simple-table class="time-window-table">
                                                                                            <thead>
                                                                                                <tr>
                                                                                                    <th>Day</th>
                                                                                                    <th>Start Hour</th>
                                                                                                    <th>Start Time</th>
                                                                                                    <th>End Hour</th>
                                                                                                    <th>End Time</th>
                                                                                                    <th>Actions</th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                <tr v-if="!deliveryRule.timeWindows || !deliveryRule.timeWindows.length">
                                                                                                    <td colspan="6" class="text-center text--disabled">
                                                                                                        No time windows defined.
                                                                                                    </td>
                                                                                                </tr>
                                                                                                <tr
                                                                                                    v-for="(window, windowIndex) in deliveryRule.timeWindows"
                                                                                                    :key="`${deliveryRule.code}-time-window-${window.id || windowIndex}`"
                                                                                                >
                                                                                                    <td>
                                                                                                        <v-select
                                                                                                            dense
                                                                                                            outlined
                                                                                                            hide-details
                                                                                                            :items="weekdayOptions"
                                                                                                            item-text="text"
                                                                                                            item-value="value"
                                                                                                            v-model="window.day"
                                                                                                            label="Day"
                                                                                                            @change="onCompleteDeliveryRuleCondition(idxx)"
                                                                                                        />
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <v-select
                                                                                                            dense
                                                                                                            outlined
                                                                                                            hide-details
                                                                                                            :items="hourOptions"
                                                                                                            item-text="text"
                                                                                                            item-value="value"
                                                                                                            v-model="window.startHour"
                                                                                                            label="Start Hour"
                                                                                                            @change="onCompleteDeliveryRuleCondition(idxx)"
                                                                                                        />
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <v-select
                                                                                                            dense
                                                                                                            outlined
                                                                                                            hide-details
                                                                                                            :items="minuteOptions"
                                                                                                            item-text="text"
                                                                                                            item-value="value"
                                                                                                            v-model="window.startMinute"
                                                                                                            label="Start Time"
                                                                                                            @change="onCompleteDeliveryRuleCondition(idxx)"
                                                                                                        />
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <v-select
                                                                                                            dense
                                                                                                            outlined
                                                                                                            hide-details
                                                                                                            :items="hourOptions"
                                                                                                            item-text="text"
                                                                                                            item-value="value"
                                                                                                            v-model="window.endHour"
                                                                                                            label="End Hour"
                                                                                                            @change="onCompleteDeliveryRuleCondition(idxx)"
                                                                                                        />
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <v-select
                                                                                                            dense
                                                                                                            outlined
                                                                                                            hide-details
                                                                                                            :items="minuteOptions"
                                                                                                            item-text="text"
                                                                                                            item-value="value"
                                                                                                            v-model="window.endMinute"
                                                                                                            label="End Time"
                                                                                                            @change="onCompleteDeliveryRuleCondition(idxx)"
                                                                                                        />
                                                                                                    </td>
                                                                                                    <td class="text-right">
                                                                                                        <v-btn icon small color="red" @click="removeTimeWindow(idxx, windowIndex)">
                                                                                                            <v-icon small>mdi-delete</v-icon>
                                                                                                        </v-btn>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </v-simple-table>
                                                                                        <div class="d-flex justify-end mt-3">
                                                                                            <v-btn small color="white" style="color: black;" @click="addTimeWindow(idxx)">
                                                                                                <v-icon class="mr-2">mdi-plus</v-icon>
                                                                                                Add Time Window
                                                                                            </v-btn>
                                                                                        </div>
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </v-tab-item>
                                                                            <v-tab-item transition="true">
                                                                                <v-row>
                                                                                    <v-col cols="12" md="4">
                                                                                        <v-combobox
                                                                                            v-model="deliveryRule.ruletags"
                                                                                            :items="[]"                                                                                                                                                                                                                                                                            
                                                                                            label="Add Tags"
                                                                                            multiple       
                                                                                            chips                                                                                     
                                                                                            deletable-chips=true
                                                                                        ></v-combobox>
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </v-tab-item>
                                                                            <v-tab-item transition="true">  
                                                                                <!-- <v-card-title class="text-center" style="color: black;">Non-operational Adpoint Count Day </v-card-title>
                                                                                <v-btn class="ma-2" dark color="success" :loading="loading" @click="fetchRuleAnalysisData(idxx)">                                                                                    
                                                                                    Calculate
                                                                                </v-btn>    -->
                                                                                <div class="d-flex justify-center mt-2" style="width: 100%">
                                                                                    <v-btn dark color="primary" @click="calculateDeliveryRuleAnalytics(deliveryRule, idxx)">
                                                                                        <v-icon>mdi-reload</v-icon>
                                                                                        Recalculate Rule
                                                                                    </v-btn>
                                                                                </div>                                                                                
                                                                                <div v-if="pollingScenarioStatus=='started' || pollingScenarioInProgress==1" class="justify-center align-center" style="font-size: 1.5em;">
                                                                                    <base-card>
                                                                                        <!-- <v-card-title class="text-center">Calculating... </v-card-title> -->
                                                                                        <v-card-text>
                                                                                            <!-- <div v-if="analysisdata && analysisdata.mustSave==1" class="text-center">
                                                                                                <div style="font-size: 1.5em">Please save Delivery Rule to view Analysis</div>
                                                                                            </div>
                                                                                            <div v-else class="text-center">
                                                                                                <div>Calculating...</div>
                                                                                                <v-progress-circular
                                                                                                    :rotate="-90"
                                                                                                    :size="100"
                                                                                                    :width="15"
                                                                                                    :value="pollingScenarioProgress"
                                                                                                    color="primary"
                                                                                                >
                                                                                                    {{ pollingScenarioProgress }}%
                                                                                                </v-progress-circular>
                                                                                            </div>-->

                                                                                            <div class="text-center">
                                                                                                <div>Calculating...</div>
                                                                                                <v-progress-circular
                                                                                                    :rotate="-90"
                                                                                                    :size="100"
                                                                                                    :width="15"
                                                                                                    :value="pollingScenarioProgress"
                                                                                                    color="primary"
                                                                                                >
                                                                                                    {{ pollingScenarioProgress }}%
                                                                                                </v-progress-circular>
                                                                                            </div>  
                                                                                        </v-card-text>
                                                                                        <v-progress-linear
                                                                                            :active="true"
                                                                                            :indeterminate="true"
                                                                                            absolute
                                                                                            bottom
                                                                                            color="red accent-4"
                                                                                        />
                                                                                    </base-card>                                                                                    
                                                                                </div>
                                                                                <div v-else>                                                                                    
                                                                                    <chart-card title="Estimated Capacity Distribution Per Day">
                                                                                        <template slot="chart">
                                                                                        <div v-if="analysisdata && deliveryRule.network && deliveryRule.startdate && deliveryRule.enddate" id="basicArea-chart" style="min-height: 365px">
                                                                                            <apexchart
                                                                                            type="bar"
                                                                                            height="350"
                                                                                            :options="getCapacityDistributionPerDayData(getDurationInDays(deliveryRule), deliveryRule.startdate, deliveryRule.enddate, analysisdata).chartOptions"
                                                                                            :series="getCapacityDistributionPerDayData(getDurationInDays(deliveryRule), deliveryRule.startdate, deliveryRule.enddate, analysisdata).series"
                                                                                            />
                                                                                        </div>
                                                                                        </template>
                                                                                    </chart-card>
                                                                                </div>

                                                                            </v-tab-item>
                                                                        </v-tabs>                                                                                                                                    
                                                                </v-col>
                                                                
                                                            </v-row>
                                                            <v-row>
                                                                <v-col cols="12" class="d-flex justify-center">
                                                                    <v-btn dark color="primary" style="min-width: 50%;" @click="saveDeliveryRule(deliveryRule)">
                                                                            <v-icon class="pr-2">mdi-content-save</v-icon>
                                                                            Save Rule
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-text>
                                                    </v-card>
                                                </div>
                                                <h5 class="mt-4 mb-2 pr-4" style="text-align: right;">Total Media Delivery Cost: {{ formatEuro(totalCampaignMediaCost) }}</h5>
                                            </v-form>
                                            <v-btn dark color="primary" class="mt-2" style="width: 100%;" @click="addDeliveryRule">
                                                    <v-icon class="pr-2">mdi-plus-box</v-icon>
                                                    Add A Delivery Rule
                                            </v-btn>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>                                
                                <v-tab-item transition="false">
                                    <v-card flat>
                                        <v-card-text v-if="is_proposal!=true">
                                            <p>
                                                Perform actions to define the state of the Campaign. These actions trigger timeline recalculation of targeted adpoints.
                                            </p>
                                            <div>                                                
                                                <v-list>
                                                    <v-list-item class="ma-2" >
                                                        <v-list-item-title >
                                                            <v-btn  class="ma-2" 
                                                                @click="recalculateCampaign"
                                                                :dark="!!(statusCalc!=='archived')"  
                                                                :loading="loading"     
                                                                :disabled="!!(statusCalc==='archived')"                                                                                                                                                    
                                                            >                                        
                                                                Release Latest Changes
                                                            </v-btn>                                                            
                                                            <span class="ml-4">Click to make your latest changes public.</span>
                                                        </v-list-item-title>

                                                    </v-list-item>
                                                    <v-list-item class="ma-2" >
                                                        <v-list-item-title >
                                                            <v-btn class="ma-2" 
                                                                @click="releaseCampaign"
                                                                color="blue" 
                                                                :dark="!!(statusCalc!=='archived')"
                                                                :loading="loading"     
                                                                :disabled="!!(statusCalc==='archived')"                                                                                                                                                         
                                                            >                                        
                                                                Publish
                                                            </v-btn>
                                                            <span class="ml-4">Publish this campaign.</span>
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item class="ma-2" >
                                                        <v-list-item-title >
                                                            <v-btn class="ma-2" 
                                                                @click="completeCampaign"
                                                                color="blue" 
                                                                :dark="!!(statusCalc!=='archived')"
                                                                :loading="loading"       
                                                                :disabled="!!(statusCalc==='archived')"                                                                        
                                                                
                                                            >                                        
                                                                Complete
                                                            </v-btn>                                                            
                                                            <span class="ml-4">Immediately complete and stop this campaign.</span>
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item class="ma-2">
                                                        <v-list-item-title >
                                                            <!-- <v-btn class="ma-2" 
                                                                @click="archiveCampaign"
                                                                color="blue" 
                                                                style="color: white;"
                                                                :loading="loading"   
                                                                :disabled="!!(statusCalc!=='completed')" 
                                                            >                                        
                                                                Archive
                                                            </v-btn>      -->
                                                            <v-checkbox
                                                                style="width: 200px;"
                                                                class="ma-2"
                                                                v-model="must_archive"
                                                                label="Archive   (Status must already be 'Completed' for archiving to be available)"  
                                                                :disabled="!!(statusCalc!=='completed')"         
                                                            />                                                          
                                                            <!-- <span class="ml-4"></span> -->
                                                        </v-list-item-title>
                                                    </v-list-item>                                    
                                                </v-list>

                                            </div>
                                        </v-card-text>
                                        <v-card-text v-else>
                                            <p>
                                                This Campaign is currently a Proposal.
                                            </p>
                                            <div>                                                
                                                <v-list>
                                                    <v-list-item class="ma-2" >
                                                        <v-list-item-title >
                                                            <v-btn  class="ma-2"  
                                                            @click="exportProposal"  
                                                            :loading="loading"
                                                            color="white" 
                                                            style="color: black;"                                                                                                                                               
                                                            >                 
                                                                <v-icon class="mr-3">mdi-file-document-outline</v-icon>                       
                                                                Export Proposal
                                                            </v-btn>                                                            
                                                            <span class="ml-4">Export a Proposal spreadsheet report.</span>
                                                        </v-list-item-title>

                                                    </v-list-item> 
                                                    <v-list-item class="ma-2" >
                                                        <v-list-item-title >
                                                            &nbsp;
                                                            <span class="ml-4">&nbsp;</span>
                                                        </v-list-item-title>

                                                    </v-list-item>  
                                                    <v-list-item class="ma-2" >
                                                        <v-list-item-title >
                                                            &nbsp;
                                                            <span class="ml-4">&nbsp;</span>
                                                        </v-list-item-title>

                                                    </v-list-item> 
                                                    <v-list-item class="ma-2" >
                                                        <v-list-item-title >
                                                            &nbsp;
                                                            <span class="ml-4">&nbsp;</span>
                                                        </v-list-item-title>

                                                    </v-list-item> 
                                                    <v-list-item v-if="status=='draft'" class="ma-2" >
                                                        <v-list-item-title >
                                                            <v-btn  class="ma-2" 
                                                            @click="rejectProposal"  
                                                            :loading="loading"
                                                            color="red" 
                                                            style="color: white;"                                                                                                                                                
                                                            >                     
                                                                <v-icon class="mr-3">mdi-cancel</v-icon>                   
                                                                Reject Proposal
                                                            </v-btn>                                                            
                                                            <span class="ml-4">Mark this proposal as Rejected.</span>
                                                        </v-list-item-title>

                                                    </v-list-item>      
                                                    <v-list-item v-if="status=='archived'" class="ma-2" >
                                                        <v-list-item-title >
                                                            <v-btn  class="ma-2" 
                                                            @click="undoRejectProposal"  
                                                            :loading="loading"                                                                                                                                              
                                                            >                                                                                     
                                                                Undo Rejection
                                                            </v-btn>                                                            
                                                            <span class="ml-4">Returns a Rejected Campaign back to Proposal Status.</span>
                                                        </v-list-item-title>

                                                    </v-list-item>                                                                                  
                                                </v-list>

                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                            </v-tabs>
                        </v-card>
                    </v-card-text>
                </base-card>

            </div>
        </v-sheet>        
        <v-snackbar
            v-model="snackbar"
            :timeout="4000"
            bottom
            tile
            :color="snackbarColor + ' -accent-2'"            
            >
            {{ snackbarMessage }}
        </v-snackbar>
        <v-dialog
            v-model="showAssetsExplorer"            
            max-width="90%"            
        >
            <div style="background-color: #1e1e1e;">
                <AssetExplorer @select="setSelectedAsset" :pickerMode="true" ></AssetExplorer>
            </div>            
        </v-dialog>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import {api, srvApi, srvApiNoAuth, PATH, getAssetUrl} from "src/api/index"; 
import { fieldNotEmpty, numberFieldNotEmpty, fieldMinLength, fieldSelectionArrayNotEmpty, endDateLaterThanStart, endTimeLaterThanStart } from "src/core/vuetify-validators.js";
import DatepickerPopup from "@/components/core/DatepickerPopup";
import TimepickerPopup from "@/components/core/TimepickerPopup";
import AdvancedGridFiltersListNew from "@/components/core/AdvancedGridFiltersListNew";
import {parseDate, formatDate, formatDateLabel, getCtrlDateTime, setCtrlDate, setCtrlTime} from '@/core/date-utils.js';
import { formatCurrencyEUR, formatInteger as formatIntegerLabel } from '@/core/number-utils.js';

import { statusCalc as sCalc } from "@/core/ui-utils.js"

import ChartCard from "@/components/card/ChartCard";

import AssetExplorer from '@/views/assets/asset-explorer';

const RULE_PAYLOAD_STRIP_KEYS = [
    'filterAvailability',
    'scopedAttributeOptions',
    'availabilityLoading',
    'availableAdpointCount',
    'attributeToAdd',
    'listItems'
];

const ASSET_PAYLOAD_STRIP_KEYS = [
    'uploadProgress',
    'analysisEstSecondsLeft',
    'uploadResult',
    'mob_uploadProgress',
    'mob_analysisEstSecondsLeft',
    'mob_uploadResult',
    'pme_upload_status'
];

// import {
//   stackedColumn,
// } from "@/data/apexChart";
 
export default {
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Campaign Edit'
    },
    components: {        
        DatepickerPopup,
        TimepickerPopup,
        "advanced-grid-filters-list": AdvancedGridFiltersListNew,
        ChartCard,
        AssetExplorer
    },
    data() {     
        const hourOptions = Array.from({ length: 24 }, (_, index) => {
            const label = index.toString().padStart(2, '0');
            return { value: label, text: label };
        });
        const minuteOptions = Array.from({ length: 12 }, (_, index) => {
            const label = (index * 5).toString().padStart(2, '0');
            return { value: label, text: label };
        });
        return {

            // filtercriteria: null,
            // filterfields: [],

            //demo data,
            totalCampaignMediaCost: 0,
            cmpntimezone: "UTC+02:00",
            targetedAsset: null,
            targetedAssetIndex: null,
            showAssetsExplorer: false,
            assetSelectionInProgress: false,
            uploadingProductmeInProgress: false,
            series: [72],
            chartOptions: {
                chart: {
                height: 120,
                type: "radialBar"
                },
                
            
                colors:["#33cc33"],
                plotOptions: {
                radialBar: {
                    hollow: {
                    margin: 0,
                    size: "40%"
                    },
                
                    dataLabels: {
                    show: true,
                    name: {
                        offsetY: 0,
                        show: false,
                        color: "green",
                        fontSize: "13px"
                    },
                    value: {
                        offsetY: 6,
                        color: "#828d99",
                        fontSize: "15px",
                        show: true,
                        fontWeight: 700,
                    }
                    }
                }
                },
            
                stroke: {
                lineCap: "round",
                },
                labels: ["Progress"]
            },
            stackedColumn: {
                series: [{
                    name: 'Already Allocated',
                    data: [13, 23, 20, 8, 13, 27, 33, 12],                    
                }, {
                    name: 'Available',                    
                    data: [44, 55, 41, 67, 22, 43, 21, 49],
                }, {
                    name: 'Estimated Impact',
                    data: [11, 17, 15, 15, 21, 14, 15, 13],
                }],
                chartOptions: {
                    chart: {
                    toolbar: {
                        show: false,
                    },
                    stacked: true,
                    stackType: '100%',
                    },
                    responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0,
                        },
                    },
                    }],
                    xaxis: {
                    categories: ['2011 Q1', '2011 Q2', '2011 Q3', '2011 Q4', '2012 Q1', '2012 Q2',
                        '2012 Q3', '2012 Q4',
                    ],
                    },
                    fill: {
                    opacity: 1,
                    },

                    legend: {
                    position: 'top',
                    },
                },
            },











            //primary data
            status: 'draft',
            id: null,
            
            
            //first tab "Basic Info"
            campaignid: '',
            campaignid_base: '',
            external_campaignid: '',
            is_proposal: false,
            brand: '',
            monetization: '',
            owner: null,
            brand_lead: null,
            description: '',
            priority: '',            
            startdate: null,
            starttime: null,
            enddate: null,
            endtime: null,
            targetnetworks: [],
            //second tab "Content"
            assets: [],
            deliveryrules: [],
            budgetrules: [],
            advancedfilter: {},

            analysisdata: null,

            must_archive: false,

            // isExternal: false,
            // assetType: '',
            // assetName: '',
            // duration: '',
            // assetUrl: '',
            // storagePath: '',
            // storageTarget: '',

            //ui mechanics    
            crud_code: null,  
            createMode: false,                              
            assetCreateFormValid: true,
            deliveryRuleFormValid: true,
            budgetRuleFormValid: true,
            basicInfoFormValid: true,            
            selectedTab: null,
            previousTabIndex: null,            
            loading: false,            
            snackbar: false,
            snackbarColor: 'green',
            snackbarMessage: '',
            error: '',
            polling: null,
            pollingScenarioStatus: 'completed',
            pollingScenarioInProgress: 0,   
            pollingScenarioRuleIndex: 0,
            pollingScenarioProgress: 100,
            pollingScenarioStatus_Previous: 'completed',
            //reference data             
            networkOptions: [],            
            brandOptions: [],
            brandLeadOptions: [],
            networkOwnerOptions: [],
            priorityOptions: [
                1000, 900, 800, 700, 600, 500, 400, 300, 200, 100
            ],
            assetTypeOptions: [                
                {text: "Image", value: "image"},
                {text: "Video", value: "video"},
                {text: "Html Bundle", value: "htmlbundle"},                
            ],
            storageTargetOptions: [ { value: "adpointsblob", text: "Adpoints Blob Storage" } ],
            attributeOptions: [],
            eventTypeOptions: [
                {value: "impression", text: "Cost Per Play (CPP)"}, 
                {value: "costperday", text: "Cost Per Day (CPD)"},
                {value: "costperunit", text: "Cost Per Unit (CPU)"},
                {value: "costperclick", text: "Cost Per Click (CPC)"},
                {value: "costpermille", text: "Cost Per Mille (CPM)"},
                {value: "costpercontact", text: "Cost Per Lead (CPL)"},                
                {value: "customevent", text: "Custom Event"}
            ],
            budgetCostTypeOptions: [
                {value: 'cpc', text: 'CPC (Cost Per Click)'},
                {value: 'cpm', text: 'CPM (Cost Per Mille)'},
            ],
            deliveryRuleConditionDebounceMs: 1500,
            deliveryRuleConditionDebounceTimers: {},
            deliveryRuleConditionDebouncePending: {},
            weekdayOptions: [
                {value: 'everyday', text: 'Every Day'},
                {value: 'monday', text: 'Monday'},
                {value: 'tuesday', text: 'Tuesday'},
                {value: 'wednesday', text: 'Wednesday'},
                {value: 'thursday', text: 'Thursday'},
                {value: 'friday', text: 'Friday'},
                {value: 'saturday', text: 'Saturday'},
                {value: 'sunday', text: 'Sunday'},
            ],
            hourOptions,
            minuteOptions,
            //validation                                             
            requiredRules: [
                fieldNotEmpty                
            ],
            numberRequiredRules: [
                numberFieldNotEmpty                
            ],
            arrayRequiredRules: [
                fieldSelectionArrayNotEmpty
            ],
            endDateRequiredRules: [
                fieldNotEmpty,
                v => endDateLaterThanStart(v, this.endtime, this.startdate, this.starttime),
            ],
            endTimeRequiredRules: [
                fieldNotEmpty,
                v => endTimeLaterThanStart(v, this.enddate, this.startdate, this.starttime),
            ]
        }
    },
    computed: {
        // budgetCustomEventOptions() {            
        //     return this.deliveryrules.map((d) => {

        //     });
        // },
        ...mapGetters(['loggedInUser']),
        filteredTargetNetworks() {
            let rslt = [];
            let selectedOwner = this.owner;
            rslt = this.networkOptions.filter(n=> (n.extra.targeting_rules.find(r=>r.networkowner_id==selectedOwner) != null) || n.extra.network_owner == selectedOwner )
            return rslt
        },
        selectedNetworkOptions() {
            return this.networkOptions.filter(n=> this.targetnetworks.includes(n.value))
        },

        // mediaCostTotal() {
        //     let sum=0;
        //     for(let i=0; i<this.deliveryRules.length; i++) {
        //         sum+=this.deliveryRules[i].finalMediaCost_Total;
        //     }
        //     return sum            
        // },
        // statusCalc() {                        
        //     if(this.status === 'released') {
        //         let startdatetime = getCtrlDateTime(this.startdate, this.starttime);
        //         if(startdatetime <= Date.now() ) {
        //             return 'running';
        //         }
        //         else {
        //             return 'queued';
        //         }
        //     }
        //     else if (this.status === 'completed') {                
        //         let enddatetime = getCtrlDateTime(this.enddate, this.endtime);
        //         if(enddatetime <= Date.now()) {
        //             return 'completed';
        //         }
        //         else {
        //             return 'stopped';
        //         }
        //     }
        //     return this.status;
        // },
        statusCalc() {
            if(this.startdate && this.starttime && this.enddate && this.endtime) {
                return sCalc({is_proposal: this.is_proposal, status: this.status, startdatetime: getCtrlDateTime(this.startdate, this.starttime), enddatetime: getCtrlDateTime(this.enddate, this.endtime), must_archive: this.must_archive});
            }
            else {
                return '';
            }            
        },
        campaignBrandDescr() {     
            if(this.brand && this.brandOptions) {
                const rslt = this.brandOptions.filter(i=> this.brand === i.code);                
                if(rslt) {
                    return rslt;
                }                                           
            }                   
            return [];
        },        
        // status() {
        //     return (this.disabled) ? "Disabled" :
        //             (this.invitation_code) ? "Invited" :
        //             (this.activation_date === "" || this.activation_date == null) ? "Awaiting Activation" : "Active";                    
        // }
    },
    beforeDestroy () {
        Object.values(this.deliveryRuleConditionDebounceTimers).forEach((timerId) => {
            clearTimeout(timerId);
        });
        clearInterval(this.polling)
    },
    async created() {
        // const rsp = await api.campaign.getInitData(); 
        // const allData = rsp.data;
        // this.networkOptions = allData.networks.map(n=> { return { value: n.code, text: n.title }});
        // this.brandOptions = allData.brands.map(n=> { return { value: n.code, text: n.title }});   
        
        const rsp = await api.adpoint.getInitData();
        this.networkOptions = rsp.data.networkOptions.filter(n=>n.extra.archived===false);
        this.deviceTypeOptions = rsp.data.deviceTypeOptions;
        this.brandOptions = rsp.data.brandOptions;        
        this.brandLeadOptions = rsp.data.brandLeadOptions;
        this.networkOwnerOptions = rsp.data.networkOwnerOptions;
        this.attributeOptions = [
            ...rsp.data.attributeOptions.map(i=> { 
                return {
                    ...i, 
                    text: i.text,
                    extra: {
                        ...(i.extra || {}),
                        sourceType: 'dynamic'
                    }
                }
            }), 
            ...rsp.data.standardAttributeOptions.map(i=> { 
                return {
                    ...i, 
                    text: i.text,
                    extra: {
                        ...(i.extra || {}),
                        sourceType: 'standard'
                    }
                }
            })
        ];
        
        if(this.$route.params.code) {            
            this.crud_code = this.$route.params.code;       
            this.createMode = false;                   
        }
        else {            
            this.createMode = true;
        }
        if(!this.createMode) {
            const resp = await api.campaign.getOne(this.crud_code);            
            this.initializeFormData(resp.data);
        } 
        //this.pollData();
        
    },
    async mounted() {           
        /*
        // const rsp = await api.brand.getAll();            
        // this.brand_list_items = rsp.data.map(i=> {return {...i, selectvalue: i.code, selecttext: i.title}});
        const rspB = await api.brand.getOne(this.crud_code);
        if(rspB && rspB.data) {
            this.code = rspB.data.code;
            this.title = rspB.data.title;
            this.description = rspB.data.description;
            this.contact_name = rspB.data.contact_name;
            this.contact_email = rspB.data.contact_email;
            this.contact_phoneno = rspB.data.contact_phoneno;            
        }
        //this.editFormValid = true;
        */
    },
    methods: {    
        offlineDateSelected(prm1, idx) {
            this.deliveryrules[idx].offline_data.selectedDate = prm1;
            this.deliveryrules[idx].offline_data.conflicts.splice(0, this.deliveryrules[idx].offline_data.conflicts.length);
            this.deliveryrules[idx].offline_data.conflicts.push(...this.deliveryrules[idx].offline_data.allConflicts.filter(c => c.cdate == prm1));            
            this.$forceUpdate();
            console.log(JSON.stringify(prm1))  ;
            console.log(JSON.stringify(idx))  ;            
        },
        async exportProposal() {
            try {                       
                this.loading=true;
                await srvApi.downloadfile(PATH.CAMPAIGN_DOWNLOADPROPOSAL + '/' + this.id, "campaign_proposal_" + this.id + '_' + (new Date()).toISOString().substring(0,10));
            } catch (error) {
                
            } finally {
                this.loading=false;
            }
        },
        async rejectProposal() {
            try {
                this.loading=true;
                const archRslt = await api.campaign.archive(this.id);
                this.status = 'archived';
            } catch (error) {
                
            } finally {
                this.loading=false;
            }
        },
        async undoRejectProposal() {
            try {
                this.loading=true;
                const archRslt = await api.campaign.undoarchive(this.id);
                this.status = 'draft';
            } catch (error) {
                
            } finally {
                this.loading=false;
            }
        },        
        getThumbnailPath(src) {
            return src.toLowerCase()
            .replace(".png", "_thumb.png")
            .replace(".jpg", "_thumb.jpg")
            .replace(".gif", "_thumb.gif")      
            .replace(".mp4", "_thumb.png")
            .replace(".avi", "_thumb.png")
            .replace(".mov", "_thumb.png")
        },
        async setSelectedAsset(selectedAsset) {
            this.assetSelectionInProgress=true;
            let extractedDuration = "";
            this.showAssetsExplorer = false;
            if(selectedAsset?.info?.properties?.contentType?.includes("video")) {
                let resp = await api.campaign.extractduration(selectedAsset.assetUrl);
                extractedDuration = resp.data.toString();
                //extract duration on server side
            }
            if(this.targetedAssetIndex != null) {
                this.assets[this.targetedAssetIndex].assetUrl = selectedAsset.assetUrl;
                this.assets[this.targetedAssetIndex].assetName = selectedAsset.name;
                this.assets[this.targetedAssetIndex].assetType = selectedAsset?.info?.properties?.contentType?.includes("video") ? "video" : "image";
                this.assets[this.targetedAssetIndex].storagePath = "assets/" + selectedAsset.fullpath;
                const thumbPath = this.getThumbnailPath(selectedAsset.assetUrl);
                this.assets[this.targetedAssetIndex].thumbnailUrl = thumbPath;
                this.assets[this.targetedAssetIndex].uploadResult = selectedAsset.uploadResult;
                this.assets[this.targetedAssetIndex].duration = extractedDuration;
            }                        
            this.targetedAsset = null;
            this.targetedAssetIndex = null;
            this.assetSelectionInProgress=false;
        },
        openAssets(asset, index) {
            if(!this.showAssetsExplorer) {
                this.targetedAsset = asset;
                this.targetedAssetIndex = index;
                this.showAssetsExplorer = true;                
            }
            else {
                this.showAssetsExplorer = false;
                this.targetedAsset = null;
                this.targetedAssetIndex = null;
            }                      
        },
        formatInteger(src) {
            return formatIntegerLabel(src);
        },
        formatTimeLabel(timeStr) {
            if(!timeStr) {
                return '';
            }
            return timeStr.toString().substring(0,5);
        },
        formatEuro(input, fractionDigits = 2) {
            return formatCurrencyEUR(input, fractionDigits);
        },
        pollData () {
            this.polling = setInterval(async () => {
                if(this.id) {
                    let rslt = await api.campaign.calcprogress();

                    //console.log("SOMETHING SOMETHING: \n" + JSON.stringify(rslt.data, null, 2));
                    if(rslt.data.scenario.hasOwnProperty(this.id.toString())) {
                        let entry = rslt.data.scenario[this.id.toString()];
                        this.pollingScenarioStatus = entry.status;
                        this.pollingScenarioProgress = (entry.status == 'completed' ? 100 : !entry.hasOwnProperty('progress') ? 0 : entry.progress );
                        if(this.pollingScenarioStatus_Previous != this.pollingScenarioStatus) {
                            if(this.pollingScenarioStatus == 'completed') {                                
                                // //TRIGGER ANALYSIS DATA RETRIEVAL
                                // console.log('----------------------------------------------------- MUST RETRIEVE ANALYSIS DATA');
                                await this.fetchRuleAnalysisData(this.pollingScenarioRuleIndex);
                                //alert(JSON.stringify(this.analysisdata));
                                this.pollingScenarioInProgress=0;
                                clearInterval(this.polling);
                            }                            
                            //UPDATE _Previous status
                            this.pollingScenarioStatus_Previous = this.pollingScenarioStatus;
                        }
                    }     
                }                           
                //set individual properties
            }, 2000)
        },
        endDateLaterThanStart(v, endTime, startDate, startTime) {
            return endDateLaterThanStart(v, endTime, startDate, startTime);
        }, 
        endTimeLaterThanStart(v, endDate, startDate, startTime) {
            return endTimeLaterThanStart(v, endDate, startDate, startTime);
        },        
        getCapacityDistributionPerDayData(totalDays, startDate, endDate, statsData)
        {    
            let initData = {
                series: [{
                    name: 'Already Allocated',
                    data: [13, 23, 20, 8, 13, 27, 33, 12],                    
                }, {
                    name: 'Available',                    
                    data: [44, 55, 41, 67, 22, 43, 21, 49],
                }, {
                    name: 'Estimated Impact',
                    data: [11, 17, 15, 15, 21, 14, 15, 13],
                }],
                chartOptions: {
                    chart: {
                    toolbar: {
                        show: false,
                    },
                    stacked: true,
                    stackType: '99%',
                    },
                    responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0,
                        },
                    },
                    }],
                    xaxis: {
                    categories: ['2011 Q1', '2011 Q2', '2011 Q3', '2011 Q4', '2012 Q1', '2012 Q2',
                        '2012 Q3', '2012 Q4',
                    ],
                    },
                    fill: {
                    opacity: 1,
                    },

                    legend: {
                    position: 'top',
                    },
                },
            };

            // let generatedData = {
            //     allocated: [13, 23, 20, 8, 13,      27, 33, 12, 27, 15,       27, 20, 14, 33, 15,      24, 31, 22, 15, 11,       15, 22, 19, 24, 29,      24, 31, 22, 15, 11,],
            //     available: [44, 55, 41, 67, 22,     43, 21, 49, 39, 41,       78, 71, 65, 55, 41,      43, 52, 25, 43, 61,       44, 51, 60, 48, 35,      43, 52, 25, 43, 61,],  
            //     impact:    [11, 17, 15, 15, 21,     14, 15, 13, 15, 21,       11, 17, 15, 15, 21,      14, 15, 13, 15, 21,       14, 15, 13, 15, 21,      14, 15, 13, 15, 21,],
            //     days: [...Array(Math.min(totalDays, 30)).keys()].map(i=> { return 'Day ' + i }),
            // };  
            if(statsData && statsData.impact) {
                totalDays = statsData.impact.length;

                let generatedData = {
                    allocated: statsData.impact.map(r=>r.previous_allocated_capacity_impr),
                    available: statsData.impact.map(r=>r.available_capacity_impr),  
                    impact:    statsData.impact.map(r=>r.impact_capacity_impr),
                    days: [...Array(Math.min(totalDays, 30)).keys()].map(i=> { return 'Day ' + (i+1) }),
                };  

                // let generatedData = {
                //     allocated: [13, 23, 20, 8, 13,      27, 33, 12, 27, 15,       27, 20, 14, 33, 15,      24, 31, 22, 15, 11,       15, 22, 19, 24, 29,      24, 31, 22, 15, 11,],
                //     available: [44, 55, 41, 67, 22,     43, 21, 49, 39, 41,       78, 71, 65, 55, 41,      43, 52, 25, 43, 61,       44, 51, 60, 48, 35,      43, 52, 25, 43, 61,],  
                //     impact:    [11, 17, 15, 15, 21,     14, 15, 13, 15, 21,       11, 17, 15, 15, 21,      14, 15, 13, 15, 21,       14, 15, 13, 15, 21,      14, 15, 13, 15, 21,],
                //     days: [...Array(Math.min(totalDays, 30)).keys()].map(i=> { return 'Day ' + i }),
                // };  

                generatedData.allocated.splice(totalDays);
                generatedData.available.splice(totalDays);
                generatedData.impact.splice(totalDays);
                generatedData.days.splice(totalDays);            
                initData.series[0].data = generatedData.allocated;
                initData.series[1].data = generatedData.available;
                initData.series[2].data = generatedData.impact;
                initData.chartOptions.xaxis.categories = generatedData.days;
                
                return initData;
            }
            
        },
        generateRandomInteger(min, max)  {
            const diff = max - min;            
            return Math.floor(min + (Math.random() * diff));
        },
        getDurationInDays(rule) {
            const s = new Date(rule.startdate);
            const e = new Date(rule.enddate);
            const diffTime = Math.abs(e - s);
            return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; 
        },
        getDailyTarget(rule) {
            return Math.ceil(rule.eventAmountGoal / this.getDurationInDays(rule));
        },
        formatDate(date) {
            return formatDate(date);
        },  
        formatDateLabel(date) {
            return formatDateLabel(date);
        },      
        showSuccessSnackbar(message) {
            this.snackbarColor = "green";
            this.snackbarMessage = message;
            this.snackbar = true;
        },
        showFailSnackbar(message) {
            this.snackbarColor = "red";
            this.snackbarMessage = message;
            this.snackbar = true;
        },
        showSnackbar(message, color="orange") {
            this.snackbarColor = color;
            this.snackbarMessage = message;
            this.snackbar = true;
        },
        async resetOverrideMediaUnitCost(deliRule, ruleIndex) {
            //this.deliveryrules[ruleIndex].overrideMediaUnitCost = !this.deliveryrules[ruleIndex].overrideMediaUnitCost;
            await this.onCompleteDeliveryRuleCondition(ruleIndex);
            this.$forceUpdate();
            //console.log("resetOverrideMediaUnitCost: " + deliRule.overrideMediaUnitCost);
            //console.log("resetOverrideMediaUnitCost index: " + ruleIndex);

        },
        initializeFormData(initData) {
            this.id = initData.id;            
            this.campaignid = initData.campaignid_label;
            this.campaignid_base = initData.campaignid;
            this.external_campaignid = initData.external_campaignid;
            this.is_proposal = initData.is_proposal;
            this.must_archive= initData.must_archive;
            this.description= initData.description;
            this.brand= initData.brand;
            this.owner = initData.owner;
            this.brand_lead = initData.brand_lead;
            this.monetization = initData.monetization;
            this.status = initData.status;
            this.priority= initData.priority;
            this.totalCampaignMediaCost = initData.totalCampaignMediaCost;
            /*
            this.startdate= initData.startdatetime.substring(0, 10);
            this.starttime= initData.startdatetime.substring(11, 13) + ':' + initData.startdatetime.substring(14, 16);
            this.enddate= initData.enddatetime.substring(0, 10);
            this.endtime= initData.enddatetime.substring(11, 13) + ':' + initData.enddatetime.substring(14, 16);
            */
            this.startdate = setCtrlDate(initData.startdatetime);
            this.starttime = setCtrlTime(initData.startdatetime);
            this.enddate = setCtrlDate(initData.enddatetime);
            this.endtime = setCtrlTime(initData.enddatetime);

            this.targetnetworks= initData.targetnetworks;
            this.assets= initData.assets;
            this.deliveryrules= initData.deliveryrules;
            //attach properties that may not exist in db stored json data...
            this.deliveryrules.forEach(dr=> {
                if(!dr.hasOwnProperty('calc_duration_days')) {
                    dr.calc_duration_days = null;
                }
                if(!dr.hasOwnProperty('calc_event_target_daily_total')) {
                    dr.calc_event_target_daily_total = null;
                }
                if(!dr.hasOwnProperty('calcInProgress')) {
                    dr.calcInProgress = false;
                }
                if(!dr.hasOwnProperty('capacityCalcInProgress')) {
                    dr.capacityCalcInProgress = false;
                }
                if(!dr.hasOwnProperty('impactCalcInProgress')) {
                    dr.impactCalcInProgress = false;
                }
                if(dr.dailyFrequencyCap == null) {
                    dr.dailyFrequencyCap = 0;
                }
                if(dr.initialMediaCost_PerUnit == null) dr.initialMediaCost_PerUnit = 0;
                if(dr.eventTypeClusterList == null) dr.eventTypeClusterList = [];
                if(dr.proposedFinalMediaCost_PerUnit == null) dr.proposedFinalMediaCost_PerUnit = 0;
                if(dr.manualFinalMediaCost_PerUnit == null) dr.manualFinalMediaCost_PerUnit = 0;
                if(dr.finalMediaCost_PerUnit == null) dr.finalMediaCost_PerUnit = 0;
                if(dr.finalMediaCost_Total == null) dr.finalMediaCost_Total = 0;
                if(dr.overrideMediaUnitCost == null) dr.overrideMediaUnitCost = false;                
                if(!dr.hasOwnProperty('ruletags') || dr.ruletags==null) dr.ruletags = [];     
                if(!dr.hasOwnProperty('timeWindows') || dr.timeWindows == null) dr.timeWindows = [];
                
                if(!dr.hasOwnProperty('offline_data')) {
                    dr.offline_data = {
                        selectedDate: null,
                        conflictEvents: [],
                        conflicts: [],
                        allConflicts: [],
                    };
                }
                else {
                    if(!dr.offline_data.hasOwnProperty('selectedDate')) dr.offline_data['selectedDate'] = null;
                    if(!dr.offline_data.hasOwnProperty('conflictEvents')) dr.offline_data['conflictEvents'] = [];
                    if(dr.offline_data['conflictEvents'] == null) dr.offline_data['conflictEvents'] = [];
                    if(!dr.offline_data.hasOwnProperty('conflicts')) dr.offline_data['conflicts'] = [];
                    if(dr.offline_data['conflicts'] == null) dr.offline_data['conflicts'] = [];
                    if(!dr.offline_data.hasOwnProperty('allConflicts')) dr.offline_data['allConflicts'] = [];
                    if(dr.offline_data['allConflicts'] == null) dr.offline_data['allConflicts'] = [];
                    
                }
                if(!dr.hasOwnProperty('filterAvailability') || typeof dr.filterAvailability !== 'object' || dr.filterAvailability == null) {
                    dr.filterAvailability = {};
                }
                if(!dr.hasOwnProperty('scopedAttributeOptions')) {
                    dr.scopedAttributeOptions = null;
                }
                if(!dr.hasOwnProperty('availableAdpointCount')) {
                    dr.availableAdpointCount = 0;
                }
                if(!Array.isArray(dr.eventTypeOptionsScoped)) {
                    dr.eventTypeOptionsScoped = [];
                }
                if(!dr.hasOwnProperty('networkSnapshot')) {
                    dr.networkSnapshot = dr.network || null;
                }
                dr.availabilityLoading = false;
            });
            this.budgetrules= initData.budgetrules;
            this.deliveryrules.forEach((dr, idx) => {
                this.applyEventTypeOptionsForRule(idx, dr.eventTypeClusterList, dr.eventType);
            });
            this.deliveryrules.forEach((_, idx) => this.applyAvailabilityToRule(idx));
            this.deliveryrules.forEach((_, idx) => {
                if(this.deliveryrules[idx].network) {
                    this.refreshDeliveryRuleAvailability(idx);
                }
            });
            this.$refs.basicInfoForm.resetValidation();
        },
        hasValue(value) {
            if(Array.isArray(value)) {
                return value.length > 0;
            }
            return value !== null && typeof value !== 'undefined' && value !== '';
        },
        findClusterCriteriaCondition(rule) {
            if(!rule || !Array.isArray(rule.filterfields)) {
                return null;
            }
            for(const clause of rule.filterfields) {
                if(!Array.isArray(clause)) {
                    continue;
                }
                const clusterCondition = clause.find((condition) => condition && condition.value === 'clusterId');
                if(clusterCondition) {
                    return clusterCondition;
                }
            }
            return null;
        },
        isClusterCriteriaLockedForRule(rule) {
            const clusterCondition = this.findClusterCriteriaCondition(rule);
            if(!clusterCondition || !clusterCondition.criteria) {
                return false;
            }
            const isEditing = clusterCondition.criteria.editMode === true;
            const hasSelection = this.hasValue(clusterCondition.criteria.search_value);
            return hasSelection && !isEditing;
        },
        isNetworkSelectionLockedForRule(rule) {
            return this.isClusterCriteriaLockedForRule(rule);
        },
        canEditDeliveryRuleCriteria(ruleIndex, showMessage=true) {
            const rule = this.deliveryrules[ruleIndex];
            const canEdit = !!(rule && rule.network);
            if(!canEdit && showMessage) {
                this.showFailSnackbar('A Network must be selected first, to make any change to the criteria.');
            }
            return canEdit;
        },
        onAttemptCriteriaEdit(ruleIndex) {
            this.canEditDeliveryRuleCriteria(ruleIndex, true);
        },
        onAttemptNetworkChange(ruleIndex) {
            const rule = this.deliveryrules[ruleIndex];
            if(this.isNetworkSelectionLockedForRule(rule)) {
                this.showFailSnackbar("You cannot select a different network while the current cluster criteria is locked-in. Please deselect the current cluster, and switch to the desired network while the cluster is under 'Edit Mode''");
            }
        },
        onDeliveryRuleNetworkChanged(ruleIndex) {
            const rule = this.deliveryrules[ruleIndex];
            if(!rule) {
                return;
            }
            if(!Object.prototype.hasOwnProperty.call(rule, 'networkSnapshot')) {
                this.$set(rule, 'networkSnapshot', rule.network || null);
            }
            if(this.isNetworkSelectionLockedForRule(rule)) {
                rule.network = rule.networkSnapshot;
                this.showFailSnackbar("You cannot select a different network while the current cluster criteria is locked-in. Please deselect the current cluster, and switch to the desired network while the cluster is under 'Edit Mode''");
                return;
            }
            rule.networkSnapshot = rule.network || null;
            this.onCompleteDeliveryRuleCondition(ruleIndex);
        },
        onDeliveryRuleCriteriaCompleted(ruleIndex) {
            if(!this.canEditDeliveryRuleCriteria(ruleIndex, true)) {
                return;
            }
            this.onCompleteDeliveryRuleCondition(ruleIndex);
        },
        getSelectLabel(optionsList, value){
            let rslt = ''; 
            const item = optionsList.find(o=>o.value === value);
            if(item) {
                rslt = item.text;
            }
            return rslt;
        },
        normalizeEventTypeFromBackend(costType) {
            if(costType === 'costperplay') {
                return 'impression';
            }
            return costType;
        },
        normalizeEventTypeToBackend(eventType) {
            if(eventType === 'impression') {
                return 'costperplay';
            }
            return eventType;
        },
        buildEventTypeOptionsFromCluster(eventTypeClusterList) {
            if(!Array.isArray(eventTypeClusterList)) {
                return [];
            }
            const knownOptionsByValue = new Map(this.eventTypeOptions.map((entry) => [entry.value, entry]));
            const selectedValues = [];
            eventTypeClusterList.forEach((entry) => {
                const rawType = entry?.cost_type;
                const normalized = this.normalizeEventTypeFromBackend(rawType);
                if(!normalized) {
                    return;
                }
                if(normalized === 'customevent' || knownOptionsByValue.has(normalized)) {
                    if(!selectedValues.includes(normalized)) {
                        selectedValues.push(normalized);
                    }
                }
            });
            return selectedValues
                .map((value) => knownOptionsByValue.get(value))
                .filter((entry) => !!entry)
                .map((entry) => ({ ...entry }));
        },
        applyEventTypeOptionsForRule(ruleIndex, eventTypeClusterList, preferredEventType=null) {
            const rule = this.deliveryrules[ruleIndex];
            if(!rule) {
                return;
            }
            const scopedOptions = this.buildEventTypeOptionsFromCluster(eventTypeClusterList);
            this.$set(rule, 'eventTypeOptionsScoped', scopedOptions);
            if(scopedOptions.length === 0) {
                rule.eventType = null;
                return;
            }
            const hasCurrent = scopedOptions.some((entry) => entry.value === rule.eventType);
            if(hasCurrent) {
                return;
            }
            const normalizedPreferred = this.normalizeEventTypeFromBackend(preferredEventType);
            const fallback = scopedOptions.find((entry) => entry.value === normalizedPreferred) || scopedOptions[0];
            rule.eventType = fallback ? fallback.value : null;
        },
        getEventTypeOptionsForRule(ruleIndex) {
            const rule = this.deliveryrules[ruleIndex];
            if(rule && Array.isArray(rule.eventTypeOptionsScoped)) {
                return rule.eventTypeOptionsScoped;
            }
            return [];
        },
        getBudgetCustomEventOptions(rule) {            
            let dRules = this.deliveryrules.filter(d=>d.asset===rule.asset);
            let rslt = [];
            dRules.forEach((d) => {
                if(d.customEventName) {
                    rslt.push(d.customEventName);
                }
            });
            return rslt;
        },
        getThumbnailType(asset){
            if(asset.isExternal) {
                return "external";                
            }
            else if(asset.assetType === 'htmlbundle') {
                return "htmlbundle";                
            }
            else {
                return "normal";                
            }
        },
        tabClicked_BasicInfo(e) {
            this.previousTabIndex = this.selectedTab;            
        },
        tabClicked_Content(e) {
            this.previousTabIndex = this.selectedTab;            
        },
        tabClicked_Delivery(e) {
            this.previousTabIndex = this.selectedTab;            
        },
        tabClicked_Budget(e) {
            this.previousTabIndex = this.selectedTab;            
        },
        tabClicked_Summary(e) {
            this.previousTabIndex = this.selectedTab;            
        },
        tabChanged(e) {            
            switch(this.previousTabIndex) {
                case 0: //Trying to leave 'Basic Info       
                    if(this.createMode) {
                        this.$refs.basicInfoForm.validate();
                        if(!this.basicInfoFormValid) {
                            this.$nextTick(() => {
                                this.selectedTab = this.previousTabIndex;
                            })                        
                        }
                        else {
                            this.save();
                        }
                    }                                 
                    break;
                case 1: //Trying to leave 'Content'
                    break;
                case 2: //Trying to leave 'Delivery'
                    break;
                case 3: //Trying to leave 'Budget'
                    break; 
                case 4: //Trying to leave 'Summary'
                    break;                   
            }
        },
        validateEverything(showSnackMessage=true, skipDeliveryRulesEdit=false) {
            this.$refs.basicInfoForm.validate();
            this.$refs.assetCreateForm.validate();
            this.$refs.deliveryRuleForm.validate();
            //this.$refs.budgetRuleForm.validate();
            //basic info
            if(!this.basicInfoFormValid) {                
                this.showFailSnackbar("There are invalid fields on 'BASIC INFO' tab.");                                
            }
            //assets
            if(!this.assetCreateFormValid) {                
                this.showFailSnackbar("There are invalid fields on 'CONTENT' tab.");                                
            }
            else {
                this.assets.forEach(i=>i.editMode = false);
            }
            //delivery rules    
            if(!skipDeliveryRulesEdit && this.deliveryrules.find(i=>i.editMode == true)) {
                this.showFailSnackbar("Please complete/save all delivery rules that are being currently edited on 'DELIVERY' tab, before saving.");
                return false;
            }
            if(!this.deliveryRuleFormValid) {                
                this.showFailSnackbar("There are invalid fields on 'DELIVERY' tab.");                                
            }
            else {
                if(!skipDeliveryRulesEdit) {
                    this.deliveryrules.forEach(i=>i.editMode = false);
                }                
            }
            //budget
            if(this.budgetrules.find(i=>i.editMode == true)) {
                this.showFailSnackbar("Please complete/save all budget rules that are being currently edited on 'BUDGET' tab, before saving.");
                return false;
            }
            // if(!this.budgetRuleFormValid) {                
            //     this.showFailSnackbar("There are invalid fields on 'BUDGET' tab.");                                
            // }
            else {
                this.budgetrules.forEach(i=>i.editMode = false);
            }
            return this.basicInfoFormValid && this.assetCreateFormValid && this.deliveryRuleFormValid; //&& this.budgetRuleFormValid;
        },
        resetAllValidation() {
            this.$refs.basicInfoForm.validate();
            this.$refs.assetCreateForm.resetValidation();            
            this.$refs.deliveryRuleForm.resetValidation();            
            //this.$refs.budgetRuleForm.resetValidation();        
        },

        //ASSET START
        async uploadFile(file, index, isMobile=false) {
            let propPrefix = '';
            if(isMobile) {
                propPrefix='mob_';
            }
            let formData = new FormData();
            formData.append("file", file);            
            this.assets[index][propPrefix + 'analysisEstSecondsLeft'] = Math.round((file.size / (1024 * 1014)) / 8) + 15;
            if(!isMobile) {
                this.countDownTimer(index);
            }
            else {
                this.mob_countDownTimer(index);                
            }            
            this.assets[index][propPrefix + 'uploadResult'].success = null;
            this.assets[index][propPrefix + 'uploadResult'].message = '';
            try {
                const rsp = await api.campaign.uploadAsset(
                    formData, this.id.toString(), index, propPrefix + this.assets[index].id, 
                    (event) => {
                        this.assets[index][propPrefix + 'uploadProgress'] = Math.round((100 * event.loaded) / event.total);
                    }
                ); 
                this.$refs.assetCreateForm.resetValidation();
                this.assets[index][propPrefix + 'uploadProgress'] = null;
                this.assets[index][propPrefix + 'uploadResult'].success = rsp.data.success;
                this.assets[index][propPrefix + 'uploadResult'].message = rsp.data.message;
                if(rsp.data.success) {                                                            
                    this.assets[index][propPrefix + 'assetType'] = rsp.data.asset.assetType;
                    this.assets[index][propPrefix + 'assetName'] = rsp.data.asset.assetName;
                    this.assets[index][propPrefix + 'duration'] = rsp.data.asset.duration;
                    this.assets[index][propPrefix + 'assetUrl'] = rsp.data.asset.assetUrl.replace('%2F', '/');
                    this.assets[index][propPrefix + 'thumbnailUrl'] = rsp.data.asset.thumbnailUrl.replace('%2F', '/');
                    this.assets[index][propPrefix + 'storagePath'] = rsp.data.asset.storagePath;
                    this.assets[index][propPrefix + 'storageTarget'] = rsp.data.asset.storageTarget;
                    this.assets[index][propPrefix + 'uploadResult'].md5hash = rsp.data.asset.md5hash;
                }                  
            } catch (error) {
                this.assets[index].uploadSuccess = false;
                this.assets[index].uploadMesage = "Error: " + error.response.data.message;
            }            
        },
        addAsset() {
            //this.selectedTab = 0;
            if(this.assets.find(a=>a.editMode)){
                this.showFailSnackbar("Please save the asset currently being edited, before adding a new one.");
                return;
            }
            let nextIndex = this.assets.length + 1;
            let initAssetData = {
                id: this.id + '-' + nextIndex + '-' + Date.now(),
                //isNew: true,
                editMode: true,                
                uploadProgress: null,                   
                analysisEstSecondsLeft: null,
                uploadResult: {
                    success: null,
                    nessage: '',
                },                
                pme_filename: '',
                pme_activated: false,
                pme_target_networks: [...this.targetnetworks],                
                pme_upload_success: true,
                pme_upload_status: [],
                isExternal: false,
                assetType: '',
                assetName: '',
                duration: '',
                assetUrl: '',
                thumbnailUrl: '',
                storagePath: '',
                storageTarget: '',

                hasMobileAsset: false,


                mob_uploadProgress: null,                   
                mob_analysisEstSecondsLeft: null,
                mob_uploadResult: {
                    success: null,
                    nessage: '',
                },                
                mob_isExternal: false,
                mob_assetType: '',
                mob_assetName: '',
                mob_duration: '',
                mob_assetUrl: '',
                mob_thumbnailUrl: '',
                mob_storagePath: '',
                mob_storageTarget: '',


            }
            this.assets.push(initAssetData);            
            //console.log(this.$refs.assetType);
        },
        initPropertyIfNotExists(asset, propName, initValue) {
            if(!asset.hasOwnProperty(propName)){
                this.$set(asset, propName, initValue)                
            }
        },
        editAsset(asset) {
            this.initPropertyIfNotExists(asset, 'hasMobileAsset', false);
            this.initPropertyIfNotExists(asset, 'mob_uploadProgress', null);
            this.initPropertyIfNotExists(asset, 'mob_analysisEstSecondsLeft', null);
            this.initPropertyIfNotExists(asset, 'mob_uploadResult', {
                    success: null,
                    nessage: '',
                });
            this.initPropertyIfNotExists(asset, 'mob_isExternal', false);
            this.initPropertyIfNotExists(asset, 'mob_assetType', '');
            this.initPropertyIfNotExists(asset, 'mob_assetName', '');
            this.initPropertyIfNotExists(asset, 'mob_duration', '');
            this.initPropertyIfNotExists(asset, 'mob_assetUrl', '');
            this.initPropertyIfNotExists(asset, 'mob_thumbnailUrl', '');
            this.initPropertyIfNotExists(asset, 'mob_storagePath', '');
            this.initPropertyIfNotExists(asset, 'mob_storagePath', '');
            this.initPropertyIfNotExists(asset, 'mob_storageTarget', '');

            this.initPropertyIfNotExists(asset, 'pme_filename', '');
            this.initPropertyIfNotExists(asset, 'pme_activated', '');
            this.initPropertyIfNotExists(asset, 'pme_target_networks', []);
            this.initPropertyIfNotExists(asset, 'pme_upload_success', true);
            this.initPropertyIfNotExists(asset, 'pme_upload_status', []);

            asset.editMode = true;
        }, 
        saveAsset(asset) {
            this.$refs.assetCreateForm.validate();
            if(this.assetCreateFormValid) {
                asset.editMode = false;
            }            
        },        
        previewAsset(asset,isMobile=false) {
            let propPrefix = '';
            if(isMobile) {
                propPrefix='mob_';
            }
            window.open(asset[propPrefix + 'assetUrl'], "_blank");
        },
        previewAssetWebTarget(asset,isMobile=false) {
            let propPrefix = '';
            if(isMobile) {
                propPrefix='mob_';
            }
            window.open(asset[propPrefix + 'webTargetUrl'], "_blank");
        },
        clearMobileAsset(asset) {
            
            asset.hasMobileAsset = false;
            asset.mob_uploadProgress = null;             
            asset.mob_analysisEstSecondsLeft = null;
            asset.mob_uploadResult = {
                success: null,
                nessage: '',
            };
            asset.mob_isExternal = false;
            asset.mob_assetType = '';
            asset.mob_assetName = '';
            asset.mob_duration = '';
            asset.mob_assetUrl = '';
            asset.mob_thumbnailUrl = '';
            asset.mob_storagePath = '';
            asset.mob_storageTarget = '';

            //     deleteDeliveryRule(index) {
            //     this.deliveryrules.splice(index, 1);            
            // },
            

            /*
            asset.uploadProgress = null;
            asset.analysisEstSecondsLeft = null;
            asset.uploadResult.success = null;
            asset.uploadResult.message = '';
            asset.isExternal = false;
            asset.assetType = '';
            asset.assetName = '';
            asset.duration = '';
            asset.assetUrl = '';
            asset.thumbnailUrl = '';
            asset.storagePath = '';
            asset.storageTarget = '';
            */
        },
        async uploadAssetToProductMe(asset) {
            if(asset.pme_target_networks.length == 0) {
                alert("Please select at least one, Upload Target Network");
                return;
            }
            this.uploadingProductmeInProgress=true;
            try {
                const resp = await api.campaign.uploadassetproductme(asset.assetUrl, this.id, asset.pme_target_networks);
                asset["pme_filename"] = resp.data.pme_filename;
                asset["pme_upload_status"] = resp.data.pme_upload_status;                
                asset["pme_upload_success"] = resp.data.pme_upload_success;            
                if(resp.data.pme_upload_success) {
                    asset["pme_activated"] = true;
                }
            } catch (error) {
                asset["pme_upload_status"] = ['unknown error'];
                asset["pme_upload_success"] = false;
            } finally {
                this.uploadingProductmeInProgress=false;
            }
        },
        clearAsset(asset) {
            let canDelete = true;
            //ensure that all delivery rules are already saved before attempting to delete an asset
            if(this.deliveryrules.find(i=>i.editMode == true)) {
                canDelete = false;
                this.showFailSnackbar("Please Complete/save all Delivery Rules that are being currently edited on 'DELIVERY' tab, before deleting an Asset.");
            }
            else {
                //check if asset is used on a delivery rule, and prompt user to change it before deleting it.
                for(let idx=0; idx<this.deliveryrules.length; idx++) {
                    if(this.deliveryrules[idx].asset === asset.id) {
                        canDelete = false;
                        this.showFailSnackbar("This Asset is already used for Delivery Rule #" + (idx+1) + " and can not be deleted. Please replace it with another Asset before deleting it.");
                    }
                }
            }            
            if(canDelete) {
                this.assets.splice(this.assets.indexOf(asset), 1);
            }


            //     deleteDeliveryRule(index) {
            //     this.deliveryrules.splice(index, 1);            
            // },
            

            /*
            asset.uploadProgress = null;
            asset.analysisEstSecondsLeft = null;
            asset.uploadResult.success = null;
            asset.uploadResult.message = '';
            asset.isExternal = false;
            asset.assetType = '';
            asset.assetName = '';
            asset.duration = '';
            asset.assetUrl = '';
            asset.thumbnailUrl = '';
            asset.storagePath = '';
            asset.storageTarget = '';
            */
        },
        async copyAssetUrl(asset, isMobile=false) {
            let propPrefix = '';
            if(isMobile) {
                propPrefix='mob_';
            }
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(asset[propPrefix + 'assetUrl']);
            }            
            else {
                console.log(asset[propPrefix + 'assetUrl']);
            }
        },
        async copyWebTargetUrl(asset, isMobile=false) {
            let propPrefix = '';
            if(isMobile) {
                propPrefix='mob_';
            }
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(asset[propPrefix + 'webTargetUrl']);
            }            
            else {
                console.log(asset[propPrefix + 'webTargetUrl']);
            }
        },
        countDownTimer(index) {                       
                if (this.assets[index]['analysisEstSecondsLeft'] > 0) {
                    console.log("TIMER: " + this.assets[index]['analysisEstSecondsLeft']);
                    setTimeout(() => {
                        this.assets[index]['analysisEstSecondsLeft'] -= 1
                        this.countDownTimer(index)
                    }, 1000)
                }
        },
        mob_countDownTimer(index, isMobile=false, self) {               
                if (this.assets[index]['mob_analysisEstSecondsLeft'] > 0) {
                    console.log("TIMER: " + this.assets[index]['mob_analysisEstSecondsLeft']);
                    setTimeout(() => {
                        this.assets[index]['mob_analysisEstSecondsLeft'] -= 1
                        this.mob_countDownTimer(index)
                    }, 1000)
                }
        },
        externalAssetSaveValidation(value, asset, fieldName) {            
            //if(asset.isExternal) {
                if(!value) {
                    
                    return fieldName === 'assetUrl' ? 'This field is Required. Please Upload a file OR point asset to an External File.' : 'This field is Required.';
                }
                if(typeof value === 'strindeliverycalcg' && value.trim() === '') {
                    return fieldName === 'assetUrl' ? 'This field is Required. Please Upload a file OR point asset to an External File.' : 'This field is Required.';
                }

            //}
            return true;
        },
        getAssetById(assetId) {
            return this.assets.find(e=>e.id === assetId);
        },
        //ASSET END

        //DELIVERY START
        createEmptyTimeWindow() {
            return {
                id: `tw-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
                day: 'everyday',
                startHour: '00',
                startMinute: '00',
                endHour: '23',
                endMinute: '55',
            };
        },
        addTimeWindow(ruleIndex) {
            const rule = this.deliveryrules[ruleIndex];
            if(!rule) {
                return;
            }
            if(!Array.isArray(rule.timeWindows)) {
                this.$set(rule, 'timeWindows', []);
            }
            rule.timeWindows.push(this.createEmptyTimeWindow());
            this.$forceUpdate();
        },
        removeTimeWindow(ruleIndex, windowIndex) {
            const rule = this.deliveryrules[ruleIndex];
            if(rule && Array.isArray(rule.timeWindows)) {
                rule.timeWindows.splice(windowIndex, 1);
                this.$forceUpdate();
            }
        },
        setDeliveryRuleConditionLoading(ruleIndex, isLoading) {
            const rule = this.deliveryrules[ruleIndex];
            if(!rule) {
                return;
            }
            rule.calcInProgress = isLoading;
            rule.capacityCalcInProgress = isLoading;
        },
        onCompleteDeliveryRuleCondition(ruleIndex, debounceMs = this.deliveryRuleConditionDebounceMs) {
            const rule = this.deliveryrules[ruleIndex];
            if(!rule) {
                return Promise.resolve();
            }
            const normalizedDebounceMs = Number.isFinite(Number(debounceMs)) ? Math.max(0, Number(debounceMs)) : this.deliveryRuleConditionDebounceMs;
            const existingTimer = this.deliveryRuleConditionDebounceTimers[ruleIndex];
            if(existingTimer) {
                clearTimeout(existingTimer);
            }
            if(!rule.network) {
                delete this.deliveryRuleConditionDebounceTimers[ruleIndex];
                this.setDeliveryRuleConditionLoading(ruleIndex, false);
                this.applyEventTypeOptionsForRule(ruleIndex, []);
                const pendingRequest = this.deliveryRuleConditionDebouncePending[ruleIndex];
                if(pendingRequest && pendingRequest.resolve) {
                    pendingRequest.resolve();
                }
                delete this.deliveryRuleConditionDebouncePending[ruleIndex];
                return Promise.resolve();
            }
            this.setDeliveryRuleConditionLoading(ruleIndex, true);
            if(!this.deliveryRuleConditionDebouncePending[ruleIndex]) {
                this.deliveryRuleConditionDebouncePending[ruleIndex] = {};
                this.deliveryRuleConditionDebouncePending[ruleIndex].promise = new Promise((resolve, reject) => {
                    this.deliveryRuleConditionDebouncePending[ruleIndex].resolve = resolve;
                    this.deliveryRuleConditionDebouncePending[ruleIndex].reject = reject;
                });
            }
            this.deliveryRuleConditionDebounceTimers[ruleIndex] = setTimeout(async () => {
                delete this.deliveryRuleConditionDebounceTimers[ruleIndex];
                const pendingRequest = this.deliveryRuleConditionDebouncePending[ruleIndex];
                try {
                    await this.runCompleteDeliveryRuleCondition(ruleIndex);
                    if(pendingRequest && pendingRequest.resolve) {
                        pendingRequest.resolve();
                    }
                } catch (error) {
                    this.setDeliveryRuleConditionLoading(ruleIndex, false);
                    if(pendingRequest && pendingRequest.reject) {
                        pendingRequest.reject(error);
                    }
                    throw error;
                } finally {
                    delete this.deliveryRuleConditionDebouncePending[ruleIndex];
                }
            }, normalizedDebounceMs);
            return this.deliveryRuleConditionDebouncePending[ruleIndex].promise;
        },
        async runCompleteDeliveryRuleCondition(ruleIndex) {
            if(!this.deliveryrules[ruleIndex] || !this.deliveryrules[ruleIndex].network) {
                this.setDeliveryRuleConditionLoading(ruleIndex, false);
                this.applyEventTypeOptionsForRule(ruleIndex, []);
                return;
            }
            //if the 'later' implemented property 'offline_targets' does not exist, add it with a 'false' value
            if(!this.deliveryrules[ruleIndex].hasOwnProperty('offline_targets')) { 
                this.deliveryrules[ruleIndex].offline_targets = false;
            }

            //Now init offline_targets flag according to if the selected network is an offline network or not.
            let selectedNetworkDetails = this.networkOptions.filter(n => n.value == this.deliveryrules[ruleIndex].network);
            if(selectedNetworkDetails.length>0) {
                if(selectedNetworkDetails[0].extra.type=="static") {
                    this.deliveryrules[ruleIndex].offline_targets = true;
                }
                else {
                    this.deliveryrules[ruleIndex].offline_targets = false;
                }
            }

            // alert(this.deliveryrules[ruleIndex].asset);
            // alert(JSON.stringify(this.assets, null, 2)); 
            
            // let otherRuleCodes = (
            //     this.deliveryrules[ruleIndex].hasOwnProperty('offline_targets') && this.deliveryrules[ruleIndex].offline_targets
            //     ?
            //     this.deliveryrules.filter(d=> (d.hasOwnProperty('offline_targets') && d.offline_targets) ).map(d=>d.code)
            //     :
            //     this.deliveryrules.filter(d=> !(d.hasOwnProperty('offline_targets') && d.offline_targets)).map(d=>d.code)
            // )
            const deliveryCalcRulePayload = this.prepareRulePayload(this.deliveryrules[ruleIndex]);
            const deliveryCalcAssetPayload = this.prepareAssetPayload(this.assets.find(a=>a.id == this.deliveryrules[ruleIndex].asset));

            let rslt = await api.campaign.deliverycalcfull({
                campaignid: this.campaignid_base || this.campaignid,
                priority: this.priority,
                assetData: deliveryCalcAssetPayload,
                ruleData: deliveryCalcRulePayload,
                otherRuleCodes: this.deliveryrules.map(d=>d.code), //this.deliveryrules.map(d=>d.code) //otherRuleCodes //                
            });
            let availCapacityRslt = {
                data: rslt.data.capacitystats
            };

            /*

            let rslt = await api.campaign.deliverycalc({
                campaignid: this.campaignid_base || this.campaignid,
                priority: this.priority,
                assetData: deliveryCalcAssetPayload,
                ruleData: deliveryCalcRulePayload,
                otherRuleCodes: this.deliveryrules.map(d=>d.code), //this.deliveryrules.map(d=>d.code) //otherRuleCodes //                
            });

            */

            //this.deliveryrules[ruleIndex].totalAdpoints = rslt.data.calc_adpoint_total;
            this.deliveryrules[ruleIndex].totalAdpoints = rslt.data.calc_adpoint_total_with_multiview;
            this.deliveryrules[ruleIndex].calc_event_target_daily_total = rslt.data.calc_event_target_daily_total;            
            this.deliveryrules[ruleIndex].calc_duration_days = rslt.data.calc_duration_days;
            this.deliveryrules[ruleIndex].calcInProgress = false;   
            this.deliveryrules[ruleIndex].offline_targets = rslt.data.offline_targets;             

            /*

            const capacityRulePayload = this.prepareRulePayload(this.deliveryrules[ruleIndex]);
            let availCapacityRslt = await api.campaign.availablecapacity({
                campaignid: this.campaignid_base || this.campaignid,
                priority: null,
                assetData: null,
                ruleData: capacityRulePayload,
                otherRuleCodes: [],                
            });       
            
            */


            this.deliveryrules[ruleIndex].availableCapacity = availCapacityRslt.data.available_capacity_impr;
            this.deliveryrules[ruleIndex].totalCapacity = availCapacityRslt.data.total_capacity_impr;  
            this.deliveryrules[ruleIndex].initialMediaCost_PerUnit = availCapacityRslt.data.initialMediaCost_PerUnit;  
            this.deliveryrules[ruleIndex].eventTypeClusterList = Array.isArray(availCapacityRslt.data.eventTypeClusterList) ? availCapacityRslt.data.eventTypeClusterList : [];
            this.applyEventTypeOptionsForRule(ruleIndex, this.deliveryrules[ruleIndex].eventTypeClusterList, availCapacityRslt.data.initialMediaCostType);
            this.deliveryrules[ruleIndex].proposedFinalMediaCost_PerUnit = availCapacityRslt.data.proposedFinalMediaCost_PerUnit;  
            //this.deliveryrules[ruleIndex].manualFinalMediaCost_PerUnit = availCapacityRslt.data.manualFinalMediaCost_PerUnit;  
            this.deliveryrules[ruleIndex].finalMediaCost_PerUnit = availCapacityRslt.data.finalMediaCost_PerUnit;  
            this.deliveryrules[ruleIndex].finalMediaCost_Total = availCapacityRslt.data.finalMediaCost_Total; 
            this.totalCampaignMediaCost =  availCapacityRslt.data.totalCampaignMediaCost;            

            if(this.deliveryrules[ruleIndex].offline_targets) {                
                console.log(JSON.stringify(this.deliveryrules[ruleIndex].offline_data,0, ' '));
                this.deliveryrules[ruleIndex].offline_data.conflictEvents.splice(0, this.deliveryrules[ruleIndex].offline_data.conflictEvents.length);
                this.deliveryrules[ruleIndex].offline_data.conflictEvents.push(...availCapacityRslt.data.offline_data.conflictEvents);
                this.deliveryrules[ruleIndex].offline_data.conflicts.splice(0,this.deliveryrules[ruleIndex].offline_data.conflicts.length);
                this.deliveryrules[ruleIndex].offline_data.conflicts.push(...availCapacityRslt.data.offline_data.conflicts);
                this.deliveryrules[ruleIndex].offline_data.allConflicts.splice(0,this.deliveryrules[ruleIndex].offline_data.allConflicts.length);
                this.deliveryrules[ruleIndex].offline_data.allConflicts.push(...availCapacityRslt.data.offline_data.allConflicts);
            }            

            await this.refreshDeliveryRuleAvailability(ruleIndex);
            this.deliveryrules[ruleIndex].capacityCalcInProgress = false;            
            this.$forceUpdate();          
        },
        async fetchRuleAnalysisData(ruleIndex) {
            const analysisRulePayload = this.prepareRulePayload(this.deliveryrules[ruleIndex]);
            let rslt = await api.campaign.analysisdata({
                campaignid: this.campaignid_base || this.campaignid,
                priority: null,
                assetData: null,
                ruleData: analysisRulePayload,
                otherRuleCodes: [],                
            });            
            this.analysisdata = rslt.data;
        },
        extractClusterName(deliveryRule) {
            if(deliveryRule.filterfields == null) return null;
            if(!Array.isArray(deliveryRule.filterfields)) return null;
            let clusterCriteria = null;
            for(let f_outside of deliveryRule.filterfields) {
                for(let f_inside of f_outside) {
                    if(f_inside.value=="clusterId") {
                        clusterCriteria= f_inside;
                    }
                }
            }
            if(clusterCriteria == null) {
                return null;
            }
            return clusterCriteria.listItems.find(i=>i.value == clusterCriteria.criteria.search_value)?.text;
        },
        extractCriteriaDescription(deliveryRule) {
            console.log(JSON.stringify(deliveryRule.filterfields, 0, ''));
            let rslt = [];
            let basicCrit = [];
            for(let out of deliveryRule.filterfields) {
                for(let ins of out) {
                    basicCrit.push({...ins});
                }
            }
            for(let cr of basicCrit) {
                let name = cr.text;
                let operator = ":";
                let value = "";
                let valueArr = [];
                if(cr.value == "clusterId") {
                    continue;
                }
                if(cr.type == "list") {
                    value = cr.listItems.find(i=>i.value == cr.criteria.search_value)?.text;
                }
                else if(cr.type == "tagmultiple") {
                    if(cr.criteria.search_value && Array.isArray(cr.criteria.search_value)) {
                        for(let selVal of cr.criteria.search_value) {                            
                            valueArr.push(selVal.text);
                        }
                        if(valueArr.length>0) {
                            value=valueArr.join(', ');
                        }
                    }
                }
                else if(cr.type == "tagsingle") {
                    if(cr.criteria.search_value && Array.isArray(cr.criteria.search_value)) {
                        for(let selVal of cr.criteria.search_value) {                            
                            valueArr.push(selVal.text);
                        }
                        if(valueArr.length>0) {
                            value=valueArr.join(', ');
                        }
                    }
                }
                else {
                    value = cr.criteria.search_value;
                }
                if(typeof value === 'string' && value.includes(',')) {
                    const valueItems = value.split(',').map(v => v.trim()).filter(v => v.length > 0);
                    if(valueItems.length > 3) {
                        value = `${valueItems[0]} +[${valueItems.length}]`;
                    }
                }
                // if(cr.criteria.operator != "equals") {
                //     operator = cr.criteria.operator;
                // }
                rslt.push({
                    name, 
                    operator,
                    value
                })                
            }
            return rslt;
            // if(deliveryRule.filterfields == null) return null;
            // if(!Array.isArray(deliveryRule.filterfields)) return null;
            // let clusterCriteria = null;
            // for(let f_outside of deliveryRule.filterfields) {
            //     for(let f_inside of f_outside) {
            //         if(f_inside.value=="clusterId") {
            //             clusterCriteria= f_inside;
            //         }
            //     }
            // }
            // if(clusterCriteria == null) {
            //     return null;
            // }
            // return clusterCriteria.listItems.find(i=>i.value == clusterCriteria.criteria.search_value)?.text;
            //return "Criteria";
        },
        extractUnitDescription(idValue) {            
            let et = this.eventTypeOptions.find(o=>o.value == idValue);
            if(et) {
                return et.text;
            }         
            return '-';            
        },
        addDeliveryRule() {            
            //this.selectedTab = 0;
            if(this.deliveryrules.find(a=>a.editMode)){
                this.showFailSnackbar("Please save the rule currently being edited, before adding a new one.");
                return;
            }
            let nextIndex = this.deliveryrules.length + 1;            
            let initDeliveryRuleData = {
                code: this.id + '-' + nextIndex + '-' + Date.now(),
                editMode: true,
                network: null,                
                networkSnapshot: null,
                asset: null,
                totalAdpoints: null,
                availableCapacity: null,
                totalCapacity: null,                
                filterfields: [[]],
                filtercriteria: null,
                eventType: null,
                eventTypeOptionsScoped: [],
                startdate: this.startdate,
                starttime: this.starttime,
                enddate: this.enddate,
                endtime: this.endtime,
                customEventName: null,
                eventAmountGoal: null,
                dailyFrequencyCap: 0,

                initialMediaCost_PerUnit: 0,
                eventTypeClusterList: [],
                proposedFinalMediaCost_PerUnit: 0,
                manualFinalMediaCost_PerUnit: 0,
                finalMediaCost_PerUnit: 0,
                finalMediaCost_Total: 0,
                overrideMediaUnitCost: false,
                ruletags: [],
                timeWindows: [],
                filterAvailability: {},
                scopedAttributeOptions: null,
                availableAdpointCount: 0,
                availabilityLoading: false,

                offline_data: {
                    selectedDate: null,
                    conflictEvents: [],
                    conflicts: [],
                    allConflicts: []
                },

                calc_duration_days: null,
                calc_event_target_daily_total: null,
                calcInProgress: false,
            //this.applyAvailabilityToRule(this.deliveryrules.length-1);
                capacityCalcInProgress: false,
                impactCalcInProgress: false,

                offline_targets: false,

                errormsg: '',
                warningmsg: '',
                filteringTabValid: true,
                goalTabValid: true,                
                attributeToAdd: null,
                
            }
            //initDeliveryRuleData.filterfields
            // initDeliveryRuleData.filterfields[0].push(
            //     {
            //         value: "brandId",
            //         text: "Brand",
            //         criteria: {
            //             editMode: false,
            //             search_value: this.brand
            //         },
            //         type: "list",
            //         listItems: this.brandOptions
            //     }
            // );
            // initDeliveryRuleData.filterfields[0].push(
            //     {
            //         value: "deviceId",
            //         text: "Device Type",
            //         criteria: {
            //             editMode: true
            //         },
            //         type: "list",
            //         listItems: this.brandOptions
            //     },
            // );
            this.deliveryrules.push(initDeliveryRuleData);
            this.onAddDeliveryRuleFiltCondition(this.deliveryrules.length-1, {attributeToAdd: "clusterId", orClauseIndex: 0}, true)
            this.deliveryrules[this.deliveryrules.length-1][0];
            this.onCompleteDeliveryRuleCondition(this.deliveryrules.length-1);
        },
        editDeliveryRule(rule, ruleIndex) {
            // this.pollingScenarioRuleIndex = ruleIndex;
            // this.pollingScenarioInProgress=1;
            if(!Object.prototype.hasOwnProperty.call(rule, 'networkSnapshot')) {
                this.$set(rule, 'networkSnapshot', rule.network || null);
            }
            else {
                rule.networkSnapshot = rule.network || null;
            }
            rule.editMode=true;            
            this.onCompleteDeliveryRuleCondition(ruleIndex);            
        },
        deleteDeliveryRule(index) {
            this.deliveryrules.splice(index, 1);            
        },    
        async calculateDeliveryRuleAnalytics(rule, rIndex) {
            this.pollingScenarioInProgress=1;
            this.pollingScenarioStatus_Previous='started';
            this.pollingScenarioStatus='started';
            this.pollingScenarioProgress = 0;
            this.pollingScenarioRuleIndex = rIndex;
            if(await this.saveAsync(false)) {
                await this.onCompleteDeliveryRuleCondition(rIndex);
                this.pollData();
                //await this.fetchRuleAnalysisData(rIndex);
            }            
        }, 
        saveDeliveryRule(rule) {    
            let canSave = true;        
            this.$refs.deliveryRuleForm.validate();
            if(!this.deliveryRuleFormValid && rule.network && rule.asset) {
                //one or more of the 'goal' tab fields is invalid
                rule.goalTabValid = false;
                this.showFailSnackbar("Validation errors found on 'GOAL' section.")
                canSave = false;
            }
            else {
                rule.goalTabValid = true;
            }
            if(rule.filterfields.length==0 || rule.filterfields.filter(f=>f.length == 0).length > 0) {
                rule.filteringTabValid = false;
                rule.errormsg = "One or more filtering conditions must be added to this rule.";
                this.showFailSnackbar("Validation errors found on 'FILTERING' section.")
                canSave = false;
            }
            else if(rule.filterfields.filter(f=> f.filter(f=>f.criteria.editMode==true).length>0).length > 0) {
                rule.filteringTabValid = false;
                rule.errormsg = "One or more conditions are still being edited. Please complete all conditions by clicking the green 'check' icon on each one."
                this.showFailSnackbar("Validation errors found on 'FILTERING' section.")
                canSave = false;
            }
            else {
                rule.filteringTabValid = true;                
                rule.errormsg = '';
            }
            if(!this.deliveryRuleFormValid) {
                canSave = false;
            }
            if(canSave) {
                rule.editMode=false;     
                this.save(false);   
            }            
        },        





        onSearch() {

        },
        onDeleteCondition(index, {orIndex, nameToDelete}) {            
            if(!this.canEditDeliveryRuleCriteria(index, true)) {
                return;
            }
            //this.deliveryrules[index].filterfields[orIndex] = this.deliveryrules[index].filterfields[orIndex].filter(f=>f.value != nameToDelete);

            const itemToDelete = this.deliveryrules[index].filterfields[orIndex].filter(f=>f.value == nameToDelete);
            if (itemToDelete) {
                this.deliveryrules[index].filterfields[orIndex].splice(this.deliveryrules[index].filterfields[orIndex].indexOf(itemToDelete));
            }

            //const itemToDelete = this.filterfields[index].find(f=>f.value == nameToDelete);
            // if(itemToDelete) {
            //     this.filterfields[index].splice(this.filterfields[index].indexOf(itemToDelete), 1);
            // }    
            this.onCompleteDeliveryRuleCondition(index);
        },
        onAddDeliveryRuleFiltCondition(index, {attributeToAdd, orClauseIndex}, bypassNetworkGuard=false) {                 
            if(!bypassNetworkGuard && !this.canEditDeliveryRuleCriteria(index, true)) {
                return;
            }
            const availableAttributeOptions = this.getScopedAttributeOptions(index) || [];
            const selectedAttributeData = availableAttributeOptions.find(o=>o.value==attributeToAdd);            
            if(!selectedAttributeData) 
                return;            
            if(selectedAttributeData.disabled) {
                this.showSnackbar('No available values for the selected attribute with the current filters.');
                return;
            }
            const newCondition = {
                value: selectedAttributeData.extra.name,
                text: selectedAttributeData.extra.description || selectedAttributeData.extra.name,
                criteria: {
                    editMode: true
                },
                type: selectedAttributeData.extra.type, // selectedAttributeData.extra.type.startsWith('tag') ? "list" : "text",
                listItems: this.prepareListItems(selectedAttributeData.extra.valuelist || [])
            };
            if(selectedAttributeData.extra.defaultOperator) {
                newCondition.criteria.operator = selectedAttributeData.extra.defaultOperator;
            }
            this.deliveryrules[index].filterfields[orClauseIndex].push(newCondition);  
            //this.deliveryrules[index].attributeToAdd = null;
            //this.attributeToAdd = null;
        },
        addOrClause(index) {
            if(!this.canEditDeliveryRuleCriteria(index, true)) {
                return;
            }
            this.deliveryrules[index].filterfields.push([]);
        },
        onDeleteOrCondition(index, orIndex) {
            if(!this.canEditDeliveryRuleCriteria(index, true)) {
                return;
            }
            this.deliveryrules[index].filterfields.splice(orIndex, 1);
            this.onCompleteDeliveryRuleCondition(index);
        },
        getScopedAttributeOptions(ruleIndex) {
            const rule = this.deliveryrules[ruleIndex];
            if(rule && Array.isArray(rule.scopedAttributeOptions)) {
                const hasAvailability = rule.filterAvailability && Object.keys(rule.filterAvailability).length > 0;
                if(rule.scopedAttributeOptions.length > 0 || hasAvailability) {
                    return rule.scopedAttributeOptions;
                }
            }
            return this.attributeOptions;
        },
        buildRuleCriteriaPayload(rule) {
            if(!rule || !Array.isArray(rule.filterfields)) {
                return {};
            }
            const normalizedClauses = [];
            rule.filterfields.forEach((clause) => {
                if(!Array.isArray(clause)) {
                    return;
                }
                const normalizedClause = {};
                if(rule.network) {
                    normalizedClause.networkId = { type: 'number', operator: 'equals', search_value: rule.network };
                }
                clause.forEach((condition) => {
                    if(!condition || !condition.value || !condition.criteria || condition.criteria.editMode) {
                        return;
                    }
                    const operator = condition.criteria.operator;
                    const searchValue = condition.criteria.search_value;
                    if(!operator || searchValue === null || typeof searchValue === 'undefined' || (Array.isArray(searchValue) && searchValue.length === 0)) {
                        return;
                    }
                    normalizedClause[condition.value] = {
                        type: condition.type,
                        operator,
                        search_value: searchValue,
                    };
                });
                if(Object.keys(normalizedClause).length > 0) {
                    normalizedClauses.push(normalizedClause);
                }
            });
            return normalizedClauses.length > 0 ? normalizedClauses : {};
        },
        normalizeAvailabilityKey(value) {
            if(value === null || typeof value === 'undefined') {
                return '__EMPTY__';
            }
            if(typeof value === 'string') {
                return value.trim();
            }
            return String(value);
        },
        prepareListItems(list) {
            if(!Array.isArray(list)) {
                return [];
            }
            return list.map((entry) => {
                if(entry && typeof entry === 'object') {
                    return {...entry};
                }
                return { value: entry, text: entry };
            });
        },
        buildScopedValuelist(baseList, availabilityBuckets) {
            const normalizedBase = this.prepareListItems(baseList);
            if(!Array.isArray(availabilityBuckets) || availabilityBuckets.length === 0) {
                return normalizedBase;
            }
            const allowedKeys = new Set(availabilityBuckets.map((bucket) => this.normalizeAvailabilityKey(bucket.value)));
            const filtered = normalizedBase.filter((entry) => allowedKeys.has(this.normalizeAvailabilityKey(entry.value)));
            return filtered;
        },
        buildScopedAttributeOption(option, availabilityMap) {
            const fieldName = option?.value;
            const availabilityBuckets = (availabilityMap && availabilityMap[fieldName]) || [];
            const hasAvailabilityData = availabilityMap && Object.keys(availabilityMap).length > 0;
            const sourceType = option?.extra?.sourceType || null;
            const hasBuckets = Array.isArray(availabilityBuckets) && availabilityBuckets.length > 0;
            if (hasAvailabilityData && sourceType === 'dynamic' && !hasBuckets) {
                return null;
            }
            if (hasAvailabilityData && (option?.extra?.type === 'tagsingle' || option?.extra?.type === 'tagmultiple')) {
                if (!hasBuckets) {
                    return null;
                }
            }
            const scopedValuelist = this.buildScopedValuelist(option?.extra?.valuelist || [], availabilityBuckets);
            const hadSourceValues = Array.isArray(option?.extra?.valuelist) && option.extra.valuelist.length > 0;
            const hasAvailabilityValues = hasBuckets;
            const shouldDisable = hadSourceValues && hasAvailabilityValues && scopedValuelist.length === 0;
            return {
                ...option,
                disabled: shouldDisable,
                extra: {
                    ...option.extra,
                    valuelist: scopedValuelist,
                },
            };
        },
        applyAvailabilityToRule(ruleIndex) {
            const rule = this.deliveryrules[ruleIndex];
            if(!rule) {
                return;
            }
            const availability = (rule.filterAvailability && typeof rule.filterAvailability === 'object') ? rule.filterAvailability : {};
            const scopedOptions = this.attributeOptions
                .map((option) => this.buildScopedAttributeOption(option, availability))
                .filter((option) => !!option);
            this.$set(rule, 'scopedAttributeOptions', scopedOptions);
            if(!Array.isArray(rule.filterfields)) {
                return;
            }
            rule.filterfields.forEach((clause, clauseIdx) => {
                if(!Array.isArray(clause)) {
                    return;
                }
                clause.forEach((condition) => {
                    if(!condition) {
                        return;
                    }
                    const baseOption = this.attributeOptions.find((opt) => opt.value === condition.value);
                    if(!baseOption) {
                        return;
                    }
                    const scopedList = this.buildScopedValuelist(baseOption.extra?.valuelist || [], availability[condition.value] || []);
                    this.$set(condition, 'listItems', scopedList);
                });
            });
        },
        async refreshDeliveryRuleAvailability(ruleIndex) {
            const rule = this.deliveryrules[ruleIndex];
            if(!rule || !rule.network) {
                return;
            }
            const criteriaPayload = this.buildRuleCriteriaPayload(rule);
            const hasCriteria = Array.isArray(criteriaPayload) ? criteriaPayload.length > 0 : Object.keys(criteriaPayload || {}).length > 0;
            if(!hasCriteria) {
                this.$set(rule, 'filterAvailability', {});
                this.applyAvailabilityToRule(ruleIndex);
                return;
            }
            try {
                this.$set(rule, 'availabilityLoading', true);
                const rsp = await api.adpoint.getDeliveryRuleAvailability({ criteria: criteriaPayload });
                this.$set(rule, 'filterAvailability', rsp.data.availability || {});
                this.$set(rule, 'availableAdpointCount', rsp.data.totalMatched || 0);
            } catch (error) {
                console.error('Failed to retrieve cascading filter availability', error);
            } finally {
                this.applyAvailabilityToRule(ruleIndex);
                this.$set(rule, 'availabilityLoading', false);
            }
        },
        stripKeysFromObject(source, keysToStrip = []) {
            if(source === null || typeof source === 'undefined') {
                return source;
            }
            const blacklist = new Set(keysToStrip);
            return JSON.parse(JSON.stringify(source, (key, value) => {
                if (blacklist.has(key)) {
                    return undefined;
                }
                return value;
            }));
        },
        prepareRulePayload(rule) {
            if(!rule) {
                return null;
            }
            const sanitized = this.stripKeysFromObject(rule, RULE_PAYLOAD_STRIP_KEYS);
            if(sanitized && Array.isArray(sanitized.filterfields)) {
                sanitized.filterfields = sanitized.filterfields.map((clause) => {
                    if(!Array.isArray(clause)) {
                        return clause;
                    }
                    return clause.map((condition) => {
                        if(condition && condition.criteria && Object.prototype.hasOwnProperty.call(condition.criteria, 'editMode')) {
                            const { editMode, ...restCriteria } = condition.criteria;
                            condition.criteria = restCriteria;
                        }
                        return condition;
                    });
                });
            }
            return sanitized;
        },
        prepareAssetPayload(asset) {
            if(!asset) {
                return null;
            }
            return this.stripKeysFromObject(asset, ASSET_PAYLOAD_STRIP_KEYS);
        },
        //DELIVERY END



        //BUDGET START
        addBudgetRule() {
            //this.selectedTab = 0;
            if(this.budgetrules.find(a=>a.editMode)){
                this.showFailSnackbar("Please save the budget rule currently being edited, before adding a new one.");
                return;
            }
            let nextIndex = this.budgetrules.length + 1;
            let initBudgetData = {
                code: this.id + '-' + nextIndex + '-' + Date.now(),
                //isNew: true,
                editMode: true,
                
                asset: null,
                eventType: null,
                customEventName: null,
                eventCost: null,
                costType: null,
                budget: null
            }
            this.budgetrules.push(initBudgetData);            
            //console.log(this.$refs.assetType);
        },
        editBudgetRule(rule) {
            rule.editMode = true;
        }, 
        deleteBudgetRule(index) {
            this.budgetrules.splice(index, 1);            
        },
        saveBudgetRule(rule) {
            //this.$refs.budgetRuleForm.validate();
            // if(this.budgetRuleFormValid) {
            //     rule.editMode = false;
            // }            
        }, 
        //BUDGET END

        recalculateCampaign(showSuccessMessage=true) {
            const allValid = this.validateEverything();
            if(!allValid) {
                return;
            }
            this.loading = true;                           
            let saveData = this.createUpdateDto();
            api.campaign.recalculate(this.id, saveData)
                .then((rsp)=>{   
                    this.status = rsp.data.status;
                    /*
                    this.startdate= rsp.data.startdatetime.substring(0, 10);
                    this.starttime= rsp.data.startdatetime.substring(11, 13) + ':' + rsp.data.startdatetime.substring(14, 16);

                    this.enddate= rsp.data.enddatetime.substring(0, 10);
                    this.endtime= rsp.data.enddatetime.substring(11, 13) + ':' + rsp.data.enddatetime.substring(14, 16);
                    */
                    this.startdate = setCtrlDate(rsp.data.startdatetime);
                    this.starttime = setCtrlTime(rsp.data.startdatetime);
                    this.enddate = setCtrlDate(rsp.data.enddatetime);
                    this.endtime = setCtrlTime(rsp.data.enddatetime);

                    //this.startdatetime = rsp.data.startdatetime
                    if(showSuccessMessage) {
                        this.showSuccessSnackbar("Campaign Changes Update has been started and will be completed in a few minutes..");
                    }                                     
                })
                .catch((error)=>{     
                    this.showFailSnackbar(error.response.data.message);                    
                })
                .finally(()=>{
                    this.loading = false;
                })
        },

        releaseCampaign(showSuccessMessage=true) {
            const allValid = this.validateEverything();
            if(!allValid) {
                return;
            }
            this.loading = true;                           
            let saveData = this.createUpdateDto();
            api.campaign.release(this.id, saveData)
                .then((rsp)=>{   
                    this.status = rsp.data.status;
                    /*
                    this.startdate= rsp.data.startdatetime.substring(0, 10);
                    this.starttime= rsp.data.startdatetime.substring(11, 13) + ':' + rsp.data.startdatetime.substring(14, 16);

                    this.enddate= rsp.data.enddatetime.substring(0, 10);
                    this.endtime= rsp.data.enddatetime.substring(11, 13) + ':' + rsp.data.enddatetime.substring(14, 16);
                    */
                    this.startdate = setCtrlDate(rsp.data.startdatetime);
                    this.starttime = setCtrlTime(rsp.data.startdatetime);
                    this.enddate = setCtrlDate(rsp.data.enddatetime);
                    this.endtime = setCtrlTime(rsp.data.enddatetime);

                    //this.startdatetime = rsp.data.startdatetime
                    if(showSuccessMessage) {
                        this.showSuccessSnackbar("Campaign Publishing has been started and will be completed in a few minutes.");
                    }                                     
                })
                .catch((error)=>{     
                    this.showFailSnackbar(error.response.data.message);                    
                })
                .finally(()=>{
                    this.loading = false;
                })
        },
        completeCampaign(showSuccessMessage=true) {
            const allValid = this.validateEverything();
            if(!allValid) {
                return;
            }
            this.loading = true;                           
            let saveData = this.createUpdateDto();
            api.campaign.complete(this.id, saveData)
                .then((rsp)=>{   
                    this.status = rsp.data.status;
                    /*
                    this.startdate= rsp.data.startdatetime.substring(0, 10);
                    this.starttime= rsp.data.startdatetime.substring(11, 13) + ':' + rsp.data.startdatetime.substring(14, 16);

                    this.enddate= rsp.data.enddatetime.substring(0, 10);
                    this.endtime= rsp.data.enddatetime.substring(11, 13) + ':' + rsp.data.enddatetime.substring(14, 16);
                    */
                    this.startdate = setCtrlDate(rsp.data.startdatetime);
                    this.starttime = setCtrlTime(rsp.data.startdatetime);
                    this.enddate = setCtrlDate(rsp.data.enddatetime);
                    this.endtime = setCtrlTime(rsp.data.enddatetime);
                    if(showSuccessMessage) {
                        this.showSuccessSnackbar("Campaign Completion has been started and will be completed in a few minutes..");
                    }                                     
                })
                .catch((error)=>{     
                    this.showFailSnackbar(error.response.data.message);                    
                })
                .finally(()=>{
                    this.loading = false;
                })
        },
        archiveCampaign(showSuccessMessage=true) {
            const allValid = this.validateEverything();
            if(!allValid) {
                return;
            }
            this.loading = true;                           
            let saveData = this.createUpdateDto();
            api.campaign.archive(this.id, saveData)
                .then((rsp)=>{   
                    this.status = rsp.data.status;
                    /*
                    this.startdate= rsp.data.startdatetime.substring(0, 10);
                    this.starttime= rsp.data.startdatetime.substring(11, 13) + ':' + rsp.data.startdatetime.substring(14, 16);

                    this.enddate= rsp.data.enddatetime.substring(0, 10);
                    this.endtime= rsp.data.enddatetime.substring(11, 13) + ':' + rsp.data.enddatetime.substring(14, 16);
                    */
                    this.startdate = setCtrlDate(rsp.data.startdatetime);
                    this.starttime = setCtrlTime(rsp.data.startdatetime);
                    this.enddate = setCtrlDate(rsp.data.enddatetime);
                    this.endtime = setCtrlTime(rsp.data.enddatetime);
                    if(showSuccessMessage) {
                        this.showSuccessSnackbar("Campaign Archiving has been started and will be completed in a few minutes.");
                    }                                     
                })
                .catch((error)=>{     
                    this.showFailSnackbar(error.response.data.message);                    
                })
                .finally(()=>{
                    this.loading = false;
                })
        },
        createUpdateDto() {
            let startdatetime = getCtrlDateTime(this.startdate, this.starttime);
            let enddatetime = getCtrlDateTime(this.enddate, this.endtime);
            const rslt = this.createMode ? {      
                campaignid: this.campaignid,
                campaignid_label: this.campaignid,
                external_campaignid: this.external_campaignid,
                is_proposal: this.is_proposal,
                must_archive: this.must_archive,
                description: this.description,
                status: this.status,
                brand: this.brand,
                monetization: this.monetization,
                owner: this.owner,
                brand_lead: this.brand_lead,
                priority: this.priority,
                startdatetime: startdatetime,
                enddatetime: enddatetime,
                targetnetworks: this.targetnetworks,
                assets: this.assets,              
                deliveryrules: this.deliveryrules,
                budgetrules: this.budgetrules,                    
            } : {      
                campaignid_label: this.campaignid,
                external_campaignid: this.external_campaignid,
                is_proposal: this.is_proposal,
                must_archive: this.must_archive,
                description: this.description,
                status: this.status,
                brand: this.brand,
                monetization: this.monetization,
                owner: this.owner,
                brand_lead: this.brand_lead,
                priority: this.priority,
                startdatetime: startdatetime,
                enddatetime: enddatetime,
                targetnetworks: this.targetnetworks,
                assets: this.assets,              
                deliveryrules: this.deliveryrules,
                budgetrules: this.budgetrules,                    
            };
            return rslt;
        },
        save(showSuccessMessage=true) {            
            const allValid = this.validateEverything();
            if(!allValid) {
                return;
            }
            this.loading = true;                           
            let saveData = this.createUpdateDto();
            if(this.createMode) {
                api.campaign.create(saveData)
                .then((rsp)=>{   
                    if(showSuccessMessage) {
                        this.showSuccessSnackbar("Campaign saved succesfully.");
                    }                       
                    this.id = rsp.data.id;
                    this.crud_code = rsp.data.id;
                    if(this.assets.length) {
                        this.assets.splice(0,this.assets.length);
                        this.assets.push(...rsp.data.assets);
                    }

                    this.status = rsp.data.status;                    

                    /*
                    this.startdate=  rsp.data.startdatetime.substring(0, 10);
                    this.starttime= rsp.data.startdatetime.substring(11, 13) + ':' + rsp.data.startdatetime.substring(14, 16);

                    this.enddate= rsp.data.enddatetime.substring(0, 10);
                    this.endtime= rsp.data.enddatetime.substring(11, 13) + ':' + rsp.data.enddatetime.substring(14, 16);
                    */
                    this.startdate = setCtrlDate(rsp.data.startdatetime);
                    this.starttime = setCtrlTime(rsp.data.startdatetime);
                    this.enddate = setCtrlDate(rsp.data.enddatetime);
                    this.endtime = setCtrlTime(rsp.data.enddatetime);
                    this.createMode = false;                    
                    window.history.pushState({}, null, '/mng/campaigns/edit/' + this.crud_code);                    
                })
                .catch((error)=>{     
                    this.showFailSnackbar(error.response.data.message);                    
                })
                .finally(()=>{
                    this.loading = false;
                })
            }  
            else {
                let saveData = this.createUpdateDto();
                api.campaign.update(this.id, saveData)
                .then((rsp)=>{   
                    this.status = rsp.data.status;
                    /*
                    this.startdate= rsp.data.startdatetime.substring(0, 10);
                    this.starttime= rsp.data.startdatetime.substring(11, 13) + ':' + rsp.data.startdatetime.substring(14, 16);

                    this.enddate= rsp.data.enddatetime.substring(0, 10);
                    this.endtime= rsp.data.enddatetime.substring(11, 13) + ':' + rsp.data.enddatetime.substring(14, 16);
                    */
                    this.startdate = setCtrlDate(rsp.data.startdatetime);
                    this.starttime = setCtrlTime(rsp.data.startdatetime);
                    this.enddate = setCtrlDate(rsp.data.enddatetime);
                    this.endtime = setCtrlTime(rsp.data.enddatetime);
                    if(showSuccessMessage) {
                        this.showSuccessSnackbar("Campaign saved succesfully.");
                    }                                     
                })
                .catch((error)=>{     
                    this.showFailSnackbar(error.response.data.message);                    
                })
                .finally(()=>{
                    this.loading = false;
                })
            }                     
        },     
        async saveAsync(showSuccessMessage=true) {            
            const allValid = this.validateEverything(true, true);
            if(!allValid) {
                return false;
            }
            this.loading = true;                           
            let saveData = this.createUpdateDto();
            if(this.createMode) {
                try {
                    let rsp = await api.campaign.create(saveData);
                    if(showSuccessMessage) {
                        this.showSuccessSnackbar("Campaign saved succesfully.");
                    }                       
                    this.id = rsp.data.id;
                    this.crud_code = rsp.data.id;
                    if(this.assets.length) {
                        this.assets.splice(0,this.assets.length);
                        this.assets.push(...rsp.data.assets);
                    }
                    this.status = rsp.data.status;
                    /*
                    this.startdate= rsp.data.startdatetime.substring(0, 10);
                    this.starttime= rsp.data.startdatetime.substring(11, 13) + ':' + rsp.data.startdatetime.substring(14, 16);

                    this.enddate= rsp.data.enddatetime.substring(0, 10);
                    this.endtime= rsp.data.enddatetime.substring(11, 13) + ':' + rsp.data.enddatetime.substring(14, 16);
                    */
                    this.startdate = setCtrlDate(rsp.data.startdatetime);
                    this.starttime = setCtrlTime(rsp.data.startdatetime);
                    this.enddate = setCtrlDate(rsp.data.enddatetime);
                    this.endtime = setCtrlTime(rsp.data.enddatetime);
                    this.createMode = false;                    
                    window.history.pushState({}, null, '/mng/campaigns/edit/' + this.crud_code);
                } catch (error) {
                    this.showFailSnackbar(error.response.data.message);
                }      
                finally {
                    this.loading = false;
                }          
            }  
            else {
                try {
                    let saveData = this.createUpdateDto();
                    let rsp = await api.campaign.update(this.id, saveData);
                    this.status = rsp.data.status;
                    /*
                    this.startdate= rsp.data.startdatetime.substring(0, 10);
                    this.starttime= rsp.data.startdatetime.substring(11, 13) + ':' + rsp.data.startdatetime.substring(14, 16);

                    this.enddate= rsp.data.enddatetime.substring(0, 10);
                    this.endtime= rsp.data.enddatetime.substring(11, 13) + ':' + rsp.data.enddatetime.substring(14, 16);
                    */
                    this.startdate = setCtrlDate(rsp.data.startdatetime);
                    this.starttime = setCtrlTime(rsp.data.startdatetime);
                    this.enddate = setCtrlDate(rsp.data.enddatetime);
                    this.endtime = setCtrlTime(rsp.data.enddatetime);
                    if(showSuccessMessage) {
                        this.showSuccessSnackbar("Campaign saved succesfully.");
                    }
                } catch (error) {
                    this.showFailSnackbar(error.response.data.message);   
                }
                finally {
                    this.loading = false;
                }
            }
            return true;                     
        },          
    }
}
</script>
<style lang="scss">
.ul-widget-profile-img {
    position: relative;
}
.ul-widget-profile-img:after {
    // content: "";
    // position: absolute;
    // top: 44px;
    // left: 50%;
    // width: 1px;
    // height: calc(100% - 30px);
    // background: #B3C0CE;
    content: '';
    position: absolute;
    top: 44px;
    left: 50%;
    width: 1px;
    height: calc(100% - 30px);
    background: #b3c0ce;
}

.v-card__title {
    font-weight: 100;
    font-size: 1em;

    span.offlinetargets {
        font-size: 0.9em;
        color:  #FF5733 ;

        i {
            font-size: 1.1em;
            color:  #FF5733 ;
        }
    }

    
}

.v-picker__title {
    display: none !important;
}

.criteria-guard-wrapper {
    position: relative;
}

.criteria-guard-overlay {
    position: absolute;
    inset: 0;
    z-index: 10;
    cursor: not-allowed;
}

</style>
\